import React, { useEffect } from 'react';
import { generatePath } from 'react-router-dom';
import { createState, useState, Downgraded } from '@hookstate/core';
import {
    Box,
    Grid,
    TextField,
    Paper,
    InputLabel,
    RadioGroup,
    Radio,
    FormControlLabel,
    Divider,
    FormControl,
    Select,
    MenuItem,
    Card,
    CardContent,
    Typography,
    Button,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import stores
import { updateModuleState } from '../../../stores/eventStore';
// import utility and constants
import Helper from '../../../utility/helper';
// import validator from 'validator';
import ApiHelper from '../../../utility/ApiHelper';
import APIURLConstants from '../../../config/config';
import RouteConstants from '../../../constants/routeConstants';
// import Switch from '@mui/material/Switch';
// import IOSFlightRequestSwitch from '../../../sharedcomponents/switchComponent/IOSFlightRequestSwitch';
// import shared components
import ButtonContainer from '../../../sharedcomponents/buttoncontainer/buttonContainer';
import Title from '../../../sharedcomponents/title/title';
import AirTransportIcon from '../../../sharedcomponents/customIcons/airTransportIcon';
import AppBarHeader from '../../../sharedcomponents/appbarHeader/appbarHeader';
import ParticipantAutoList from '../../../sharedcomponents/participantAutoList/participantAutoList';
import { useAgentState } from '../../../hookState/AgentState';
// import moment from 'moment';
import AppConstants from '../../../constants/appConstants';
import MUIDatePicker from '../../../sharedcomponents/datePicker';
import dayjs from 'dayjs';
import PhoneNumber from '../../../sharedcomponents/PhoneNumber/phoneNumber';
import airSvg from '../../../assets/images/airSvg.svg';

const useStyles = makeStyles(() => ({
    titleContent: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-around',
        padding: '0px',
    },
    selectionContent: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'flex-start',
    },
    contentRoot: {
        paddingBottom: '0px !important',
        margin: 0,
    },
}));

const FieldContainer = (props) => {
    // console.log("props",props);
    const [formatmindate, setformatmidate] = React.useState('');
    const [formatmaxdate, setformatmaxdate] = React.useState('');
    const [datePicker, setdatepicker] = React.useState(null);
    const [disabledDates, setdisabledDates] = React.useState('');
    const [contactNo, setcontactNo] = React.useState('');
    const [phoneError, setPhoneError] = React.useState(''); 
    
    const handleDates = () => {
        if (
            props.field2 &&
            props.minDate !== '' &&
            props.maxDate !== '' &&
            props.minDate !== undefined &&
            props.minDate !== undefined
        ) {
            if (props.field2 === 'arrivalDate') {
                setformatmidate(props.minDate[0]);
                setformatmaxdate(props.maxDate[0]);
            } else if (props.field2 === 'departureDate') {
                setformatmidate(props.minDate[0]);
                setformatmaxdate(props.maxDate[0]);
            }
        }
        if (props.fromDates) {
            if (props.field2 === 'arrivalDate') {
                setdisabledDates(props.fromDates);
            }
        }
        if (props.toDates) {
            if (props.field2 === 'departureDate') {
                setdisabledDates(props.toDates);
            }
        }

        if (['dob', 'arrivalDate', 'departureDate'].includes(props.field2)) {
            setdatepicker(props.value2);
        }
    }; 
    useEffect(() => {
        handleDates();        
    },[props]);

    return (
        <>
            {props.type1 === 'text' ? (
                <TextField
                    size="small"
                    required={props.required1 ? props.required1 : false}
                    label={props.label1}
                    type={props.type1}
                    value={props.value1}
                    InputProps={props.inputProps ? props.inputProps : {}}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    onChange={(event) =>
                        props.index != undefined
                            ? props.onChange1(
                                  props.stateobj,
                                  props.field1,
                                  event.target.value,
                                  props.index
                              )
                            : props.onChange1(
                                  props.stateobj,
                                  props.field1,
                                  event.target.value,
                                  null
                              )
                    }
                    inputProps={{ maxLength: 50 }}
                />
            ) : null}
            {props.type1 === 'arrivaltext' ||
            props.type1 === 'departuretext' ? (
                <TextField
                    size="small"
                    required={props.required1 ? props.required1 : false}
                    label={props.label1}
                    type={props.type1}
                    value={props.value2}
                    InputProps={props.inputProps ? props.inputProps : {}}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    onChange={(event) =>
                        props.index != undefined
                            ? props.onChange2(
                                  props.stateobj,
                                  props.field2,
                                  event.target.value,
                                  props.index
                              )
                            : props.onChange2(
                                  props.stateobj,
                                  props.field2,
                                  event.target.value,
                                  null
                              )
                    }
                    inputProps={{ maxLength: 260 }}
                    multiline
                    rows={3}
                />
            ) : null}

            {props.type2 === 'text' ? (
                <TextField
                    size="small"
                    required={props.required2 ? props.required2 : false}
                    label={props.label2}
                    type={props.type2}
                    value={props.value2}
                    InputProps={props.inputProps ? props.inputProps : {}}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    inputProps={{ maxLength: 50 }}
                    onKeyDown={(event) => {
                        if (props.type2 === 'number') {
                            if (
                                event.key != 'ArrowUp' &&
                                event.key != 'ArrowDown' &&
                                event.key != 'Enter'
                            )
                                event.preventDefault();
                        }
                    }}
                    onChange={(event) => {
                        let str = event.target.value;
                        str = str.replace(/^\s+/g, '');
                        props.index != undefined
                            ? props.onChange2(
                                  props.stateobj,
                                  props.field2,
                                  str,
                                  props.index
                              )
                            : props.onChange2(
                                  props.stateobj,
                                  props.field2,
                                  str,
                                  null
                              );
                    }}
                    sx={{
                        maxWidth:
                            props.type2 === 'number'
                                ? { xs: '100%', sm: '270px', md: '270px' }
                                : '100%',
                    }}
                    error={
                        props.label1 === 'Person Name' && props.personErr
                            ? true
                            : false
                    }
                    helperText={
                        props.label1 === 'Person Name' && props.personErr
                            ? props.personErr
                            : ''
                    }
                />
            ) : props.type2 == 'arrivaltext' ||
              props.type2 == 'departuretext' ? null : props.type2 === 'date' ? (
                <MUIDatePicker
                label={props.label2}
                 value={
                        datePicker === null ||
                        datePicker === undefined ||
                        datePicker === ''
                            ? props.value2
                            : datePicker
                    }
                error={false}
                setValue={(newValue) => {
                                props.index != undefined
                                    ? props.onChange2(
                                          props.stateobj,
                                          props.field2,
                                          newValue,
                                          props.index
                                      )
                                    : props.onChange2(
                                          props.stateobj,
                                          props.field2,
                                          newValue,
                                          null
                                      );
                                      setdatepicker(newValue);
                            }
                }
                disablePast={
                                props.label2 == 'DOB'
                                    ? false
                                    : props.transitInfo &&
                                      props.transitInfo.draftCombineTransportID > 0
                                    ? false
                                    : true
                            }
                            minDate={
                                props.label2 == 'DOB*'
                                    ? ''
                                    : formatmindate && dayjs(formatmindate)
                            }
                            maxDate={
                                props.label2 == 'DOB*'
                                    ? ''
                                    : formatmaxdate && dayjs(formatmaxdate)
                            }
                            disabledDates={
                                props.label2 !== 'DOB*' && disabledDates !== undefined
                                    ? disabledDates
                                    : []
                            }
                            disabled={props.dateDisabled}
                            disableFuture={props.label2 == 'DOB' ? true : false}
                            disableallDates={props.disableallDates ?  true : false}
            />
                // <LocalizationProvider dateAdapter={AdapterDateFns}>
                //     <DatePicker
                //         // required
                //         label={props.label2}
                //         renderInput={(params) => (
                //             <TextField required {...params} size="small" />
                //         )}
                //         value={props.value2}
                //         inputProps={{ readOnly: true }}
                //         allowKeyboardControl={false}
                //         sx={{ width: '100%' }}
                //         disablePast={
                //             props.label2 == 'DOB'
                //                 ? false
                //                 : props.transitInfo &&
                //                   props.transitInfo.draftCombineTransportID > 0
                //                 ? false
                //                 : true
                //         }
                //         shouldDisableDate={(date) =>
                //             props.disableDate
                //                 ? props.disableDate(props.tripInfoType, date)
                //                 : undefined
                //         }
                //         onChange={(newValue) => {
                //             props.index != undefined
                //                 ? props.onChange2(
                //                       props.stateobj,
                //                       props.field2,
                //                       newValue,
                //                       props.index
                //                   )
                //                 : props.onChange2(
                //                       props.stateobj,
                //                       props.field2,
                //                       newValue,
                //                       null
                //                   );
                //         }}
                //     />
                // </LocalizationProvider>
            ) : props.type2 == 'Phonecell' ? (
                <PhoneNumber
                    name={props.label2}
                    placeholder="Contact No"
                    value={
                        contactNo === '' || props.value2
                            ? props.value2
                            : contactNo
                    }
                    onChange={(newValue) => {
                        // console.log("newValue",newValue);
                        props.index != undefined
                            ? props.onChange2(
                                  props.stateobj,
                                  props.field2,
                                  newValue,
                                  props.index
                              )
                            : props.onChange2(
                                  props.stateobj,
                                  props.field2,
                                  newValue,
                                  null
                              );
                        setcontactNo(newValue);
                    }}
                    required={true}
                    helperText={phoneError}
                    error={phoneError.length > 0 ? true : false}
                    disabled={props.disabledContactNo}
                />
            ) : props.type2 === 'select' ? (
                <FormControl fullWidth={true} size="small">
                    <InputLabel id="demo-simple-select-label">
                        {props.label2}
                    </InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={props.value2}
                        label={props.label2}
                        disabled={props.disabled2}
                        onChange={(event) => {
                            let value = event.target.value;

                            props.index != undefined
                                ? props.onChange2(
                                      props.stateobj,
                                      props.field2,
                                      value,
                                      props.index
                                  )
                                : props.onChange2(
                                      props.stateobj,
                                      props.field2,
                                      value,
                                      null
                                  );
                        }}>
                        {props.passengerCount && props.passengerCount.map((option) => (
                            <MenuItem
                                key={`passanger_${option}`}
                                value={option}>
                                {option}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            ) : props.type2 === 'ticketSelect' ? (
                <FormControl
                    fullWidth={true}
                    size="small"
                    required={props.required2 ? props.required2 : false}>
                    <InputLabel id="demo-simple-select-label">
                        {props.label2}
                    </InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={`${props.value2}`}
                        label={props.label2}
                        disabled={props.disabled2}
                        onChange={(event) => {
                            let value = event.target.value;

                            props.index != undefined
                                ? props.onChange2(
                                      props.stateobj,
                                      props.field2,
                                      value,
                                      props.index
                                  )
                                : props.onChange2(
                                      props.stateobj,
                                      props.field2,
                                      value,
                                      null
                                  );
                        }}>
                        {ticketType.map((item) => (
                            <MenuItem
                                key={`ticket_${item.key}`}
                                value={item.key}>
                                {item.value}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            ) : (
                // <LocalizationProvider dateAdapter={AdapterDateFns}>
                //     <TimePicker
                //         required
                //         label={props.label2}
                //         renderInput={(params) => (
                //             <TextField {...params} size="small" />
                //         )}
                //         value={props.value2}
                //         // inputProps={{ readOnly: true }}
                //         // allowKeyboardControl={true}
                //         // inputFormat='hh:mm a'
                //         sx={{ width: '100%' }}
                //         onChange={(newValue) => {
                //             props.onChange2(
                //                 props.stateobj,
                //                 props.field2,
                //                 newValue,
                //                 null
                //             );
                //         }}
                //     />
                // </LocalizationProvider>

                <TextField
                    size="small"
                    id="time"
                    label={props.label2}
                    type="time"
                    value={props.value2}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    // inputProps={{
                    // step: 300, // 5 min
                    // }}
                    inputProps={props.value2 != null ? {className: 'has-value'} : {}}
                    sx={{ width: '100%' }}
                    onChange={(newValue) => {
                        if (newValue.target.value != '') {
                            newValue.target.classList.add('has-value');
                        }
                        else {
                            newValue.target.classList.remove('has-value');
                        }
                        props.onChange2(
                            props.stateobj,
                            props.field2,
                            newValue.target.value,
                            null
                        );
                    }}
                />
            )}
        </>
    );
};

// const minValue = 1;
// const maxValue = 3;
// const appBarStyle = {
//     mb: 1,
//     boxShadow: 'none',
//     pt: 1,
//     pb: 1,
//     pl: 1,
//     borderTop: '1px solid #D7D7D7',
//     borderBottom: '1px solid #D7D7D7',
//     backgroundColor: '#F8F8F8',
// };
const ticketType = [
    { value: 'Business', key: 1 },
    { value: 'Economy', key: 2 },
];

const AirTransport = (props) => {
    const agentState = useAgentState();
    const agentInfo = Helper.getStorage('agentInfo');
    const gUserInfo = Helper.getStorage('userInfo');

    //const participantType = useState(null);
    const arrivalInfo = createState({
        draftCombineTransportID: 0,
        draftCombineAirTransportID: 0,
        eventID: 0,
        transportType: 'air',
        tripInfoType: 'arrival',
        //participantType: participantType.get(),
        isPrivate: '',
        totalPassengers: 1,
        ticketType: 0,
        peopleInfo: [
            {
                // name: agentState.visible.value
                //     ? gUserInfo.firstName + ' ' + gUserInfo.lastName
                //     : '',
                name: '',
                dob: null,
                err: '',
            },
            {
                name: '',
                dob: null,
                err: '',
            },
        ],
        departureAirport: '',
        arrivalAirport: '',
        arrivalDate: null,
        arrivalTime: null,
        departureDate: null,
        departureTime: null,
        arrivalAirline: '',
        arrivalFlightNo: '',
        arrivalComments: '',
        createdBy: 0,
        addedFor: 0,
        contactNo: ''
    });

    const departureInfo = createState({
        draftCombineTransportID: 0,
        draftCombineAirTransportID: 0,
        eventID: 0,
        transportType: 'air',
        tripInfoType: 'departure',
        //participantType: participantType.get(),
        isPrivate: '',
        totalPassengers: 1,
        ticketType: 0,
        peopleInfo: [
            {
                // name: agentState.visible.value
                //     ? gUserInfo.firstName + ' ' + gUserInfo.lastName
                //     : '',
                name: '',
                dob: null,
                err: '',
            },
            {
                name: '',
                dob: null,
                err: '',
            },
        ],
        departureAirport: '',
        arrivalAirport: '',
        departureDate: null,
        departureTime: null,
        arrivalDate: null,
        arrivalTime: null,
        departureAirline: '',
        departureFlightNo: '',
        departureComments: '',
        createdBy: 0,
        addedFor: 0,
        contactNo: ''
    });

    const classes = useStyles();
    // let params = useParams();
    const eventInfo = useState(null);
    const userInfo = useState(null);
    // const [autoApprove, setAutoApprove] = React.useState(0);
    const departureState = useState(departureInfo);
    const arrivalState = useState(arrivalInfo);
    const tripType = useState(null);
    const infoType = useState('arrival');
    const currentTransportInfo = useState(null);
    const disableButton = useState(false);
    const [disableBtn, setDisableBtn] = React.useState(true);
    const originalBusinessTickets = useState(0);
    const originalEconomyTickets = useState(0);
    const prevTransInfo = useState(null);
    //const noOfBusinessTicket = useState(0);
    //const noOfEconomyTicket = useState(0);
    //
 
    const totalBusinessTickets = useState(0);
    const totalEconomyTickets = useState(0);
    const remainingArrivalBusinessTickets = useState(0);
    const remainingArrivalEconomyTickets = useState(0);
    const remainingDepartureBusinessTickets = useState(0);
    const remainingDepartureEconomyTickets = useState(0);
    const [minDate, setminDate] = React.useState([]);
    const [maxDate, setMaxDate] = React.useState([]);
    const [fromDates, setfromDates] = React.useState([]);
    const [toDates, settoDates] = React.useState([]);
    const [dateDOBDisabled, setDateDOBDisabled] = React.useState(false);
    const [dateDisabled, setDateDisabled] = React.useState(false);
    const [disableallDates,setdisableallDates] = React.useState(false);
    const [passengerCount, setPassengerCount] = React.useState([1]);

    // const configDetails = useState([]);
    // const arrivalDates = useState([]);
    // const departureDates = useState([]);

    const [allParticipantList, setAllParticipantList] = React.useState(null);
    const [participant, setParticipant] = React.useState(null);
    // const [toggle, setToggle] = React.useState(false);
    //const eventState = useEventState();
    const [arrivalUsedCount, setArrivalUsedCount] = React.useState(0);
    const [departureUsedCount, setDepartureUsedCount] = React.useState(0);
    // const [arrDeptTotCount, setArrDeptTotCount] = React.useState({
    //     arrival: 0,
    //     departure: 0
    // });
    const [date, setDate] = React.useState({
        arrivalDate: null,
        departureDate: null,
    });

    const getLocalEST = (date, settime, field) => {
        return date && settime
            ? `${Helper.FormatYearDate(date)}T${settime}`
            : field == 'arrivalTime'
            ? `${Helper.FormatYearDate(date)}T23:59`
            : `${Helper.FormatYearDate(date)}T00:00`;
    };

    const setInfo = (
        stateObj,
        dateField1,
        timeField1,
        dateField2,
        timeField2
    ) => {
        let stateInfo = stateObj.attach(Downgraded).get();
        if (stateInfo[dateField1] !== null) {
            stateObj[dateField1].set(
                getLocalEST(
                    stateInfo[dateField1],
                    stateInfo[timeField1],
                    timeField1
                )
            );
        }
        if (stateInfo[dateField2] !== null) {
            stateObj[dateField2].set(
                getLocalEST(
                    stateInfo[dateField2],
                    stateInfo[timeField2],
                    timeField2
                )
            );
        }
        return stateInfo;
    };
    const getmoduleconfig = () => {
        const ModuleID = 21;
        const type = "NoOfPeopleTravelling";

        ApiHelper.get(APIURLConstants.GET_MODULE_CONFIG(ModuleID, type))
            .then((res) => { 
                const vehicleTypeConfig = res.data.find((element) => element.type === type);

                if (vehicleTypeConfig) {
                    const optionsArray = JSON.parse(vehicleTypeConfig.value);
                     let numbersArr = []
                    for (let i = 0; i < optionsArray; i++) {
                        numbersArr.push(i+1)
                    }
                    console.log(optionsArray,numbersArr);
                    setPassengerCount(numbersArr) 
                 }
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
            });
    };
    useEffect(() => {
        const userInfo = Helper.getStorage('userInfo');
        //getParticipantList();
        // console.log(Helper.isAdminUser(userInfo))
        // const eventInfo = Helper.getStorage('eventInfo');

        // ApiHelper.get(APIURLConstants.GET_EVENT_MODULES(eventInfo.eventID, 1, false))
        //     .then((res) =>
        //     {
        //         if (res.data)
        //         {
        //             res.data.map((auto) =>
        //             {
        //                 if (auto.moduleName === "Transportation")
        //                 {
        //                     setAutoApprove(auto.autoApprove)
        //                 }
        //             })
        //         }
        //     })
        if (
            !(
                Helper.isAdminUser(userInfo) ||
                (userInfo.roles && Helper.isEventAdmin(userInfo)) ||
                (userInfo.roles && Helper.isEventStaff(userInfo))
            )
        ) {
            getTotalFlightCount(userInfo.userID);
        } 
        getmoduleconfig();
    }, []);
    useEffect(() => {
        if (
            props.transitInfo &&
            (currentTransportInfo.get() == null ||
                currentTransportInfo.get().draftCombineTransportID !=
                    props.transitInfo.draftCombineTransportID)
        ) {
            let transportInfo = props.transitInfo;
            if (transportInfo.isPrivate == true) {
                arrivalState.isPrivate.set('Yes');
                departureState.isPrivate.set('Yes');
            } else {
                arrivalState.isPrivate.set('No');
                departureState.isPrivate.set('No');
            }
            if (transportInfo.draftCombineTransportID > 0) {
                tripType.set('oneway');
                if (transportInfo.addedFor && props.participantList) {
                    const index = props.participantList.findIndex(
                        (user) => user.userID == transportInfo.addedFor
                    );
                    if (index > -1) {
                        setParticipant(props.participantList[index]);
                        if (
                            transportInfo.peopleInfo &&
                            transportInfo.peopleInfo[0].dob == ''
                        ) {
                            getParticipantDob(
                                props.participantList[index].userID
                            );
                        }
                    }
                } else {
                    getParticipantListIfNotFound(transportInfo);
                }
                transportInfo.arrivalTime = `${Helper.FormatTime24(
                    transportInfo.arrivalDate
                )}`;
                transportInfo.departureTime = `${Helper.FormatTime24(
                    transportInfo.departureDate
                )}`;
                infoType.set(transportInfo.tripInfoType);
                //participantType.set(transportInfo.participantType);
                if (transportInfo.tripInfoType == 'arrival') {
                    transportInfo.arrivalAirline = transportInfo.airline;
                    transportInfo.arrivalFlightNo = transportInfo.flightNo;
                    transportInfo.arrivalComments = transportInfo.comments;
                    arrivalState.set(transportInfo);
                } else {
                    transportInfo.departureAirline = transportInfo.airline;
                    transportInfo.departureFlightNo = transportInfo.flightNo;
                    transportInfo.departureComments = transportInfo.comments;
                    departureState.set(transportInfo);
                }
                currentTransportInfo.set(transportInfo);
            }
        }
    }, [props]);
    const getParticipantListIfNotFound = (transportInfo) => {
        const gEventInfo = Helper.getStorage('eventInfo');
        const gUserInfo = Helper.getStorage('userInfo');

        if (
            Helper.isAdminUser(gUserInfo) ||
            (gUserInfo.roles && Helper.isEventAdmin(gUserInfo)) ||
            (gUserInfo.roles && Helper.isEventStaff(gUserInfo))
        ) {
            ApiHelper.get(
                APIURLConstants.GET_ADMIN_EVENT_PARTICIPANTS(gEventInfo.eventID)
            ).then((res) => {
                if (res.data.rows) {
                    const participants = res.data.rows.filter(
                        (participant) =>
                            AppConstants.EVENT_ROLES_VALUES.indexOf(
                                participant.roleName
                            ) == -1
                    );
                    const index = participants.findIndex(
                        (user) => user.userID == transportInfo.addedFor
                    );
                    if (index > -1) {
                        setParticipant(participants[index]);
                        if (
                            transportInfo.peopleInfo &&
                            transportInfo.peopleInfo[0].dob == ''
                        ) {
                            getParticipantDob(participants[index].userID);
                        }
                    }
                }
            });
        }
    };
    useEffect(() => {
        if (props.transitID != 0) {
            ApiHelper.get(
                APIURLConstants.GET_DRAFT_COMBINE_AIRTRANSPORT_ROW(
                    props.transitID
                )
            )
                .then((res) => {
                    if (res.data) {
                        let data = res.data;
                        let peopleData = [];
                        data.peopleInfo &&
                            data.peopleInfo.map((item) => {
                                let people = {
                                    name: item.name,
                                    dob: dayjs(item.dob).format('YYYY-MM-DDTHH:mm')
                                };
                                peopleData.push(people);
                            });
                            const userInfo = Helper.getStorage('userInfo');
                            if ((agentInfo && agentState.visible.value) && !(Helper.isEventAdmin(agentInfo) || Helper.isAdminUser(agentInfo) || Helper.isEventStaff(agentInfo))) {
                                const eventid = data.eventID;
                                const userId = data.addedFor
                                ApiHelper.get(
                                    APIURLConstants.GET_TAGID_BY_USERID(eventid, userId)
                                ).then((res) => {
                                    let data = res.data;
                                    let Tagsid = data[0].tagID.split(',');
                                    if (data[0].tagID && data[0].tagID != null ) {
                                        fetchEventConfig(Tagsid)
                                    }
                                    else{
                                        setdisableallDates(true);
                                    }
                                })
                            } else if (!(agentInfo && agentState.visible.value) && !(Helper.isEventAdmin(userInfo) || Helper.isAdminUser(userInfo) || Helper.isEventStaff(userInfo))) {
                                const eventid = data.eventID;
                                const userId = data.addedFor
                                ApiHelper.get(
                                    APIURLConstants.GET_TAGID_BY_USERID(eventid, userInfo.userID)
                                ).then((res) => {
                                    let data = res.data;
                                    let Tagsid = data[0].tagID.split(',');
                                    if (data[0].tagID && data[0].tagID != null ) {
                                        fetchEventConfig(Tagsid)
                                    }
                                    else{
                                        setdisableallDates(true);
                                    }
                                })
                            }
    
                            data.peopleInfo = peopleData;
                            prevTransInfo.set(data);
                        }
                    })
                    .catch((error) => {
                        console.log('error : ', error);
                    });
        }
        
    }, [props.transitID]);

    const getParticipantDob =  (userID) => {
      const eventInfo = Helper.getStorage('eventInfo');
      const guserInfo = Helper.getStorage('userInfo');
        ApiHelper.get(APIURLConstants.GET_USER(userID))
            .then((res) => {
                if (res.data) {
                    ApiHelper.get(
                        APIURLConstants.GET_TAGID_BY_USERID(eventInfo.eventID, userID)
                    ).then((res) => {
                        let data = res.data;
                        let Tagsid = data[0].tagID && data[0].tagID.split(',');
                        if (data[0].tagID && data[0].tagID != null ) {
                            if (!(Helper.isEventAdmin(guserInfo) || Helper.isAdminUser(guserInfo) || Helper.isEventStaff(guserInfo))) {
                                fetchEventConfig(Tagsid)
                            }
                        }
                        else{
                            setdisableallDates(true);
                        }
                    })
                    let data = res.data;
                    if (data.dob == null) {
                        arrivalState.peopleInfo[0]['dob'].set(null);
                        departureState.peopleInfo[0]['dob'].set(null);
                    } else {
                        arrivalState.peopleInfo[0]['dob'].set(
                            dayjs(data.dob).format('YYYY-MM-DD')
                        );
                        departureState.peopleInfo[0]['dob'].set(
                            dayjs(data.dob).format('YYYY-MM-DD')
                        );
                        if (tripType.get() == 'round') {
                            setDateDOBDisabled(true)
                        } 
                    }
                }
            })
            .catch((error) => {
                console.log(error);
                if (error.response && error.response.status === 401) {
                    props.setSnackBarProps({
                        ...props.snackBarProps,
                        openSnack: true,
                        variant: 'error',
                        message: 'Access denied',
                    });
                } else {
                    props.setSnackBarProps({
                        ...props.snackBarProps,
                        openSnack: true,
                        variant: 'error',
                        message: 'Error while creating request',
                    });
                }
            });
    };
    // const fetchEventConfig = (id) =>
    // {
    //     ApiHelper.get(APIURLConstants.GET_EVENT_CONFIG(id))
    //         .then((res) =>
    //         {
    //             if (
    //                 !Helper.isAdminUser(gUserInfo) &&
    //                 !Helper.isEventAdmin(gUserInfo)
    //             )
    //             {
    //                 configDetails.set(res.data);
    //                 if (res.data.length > 0)
    //                 {
    //                     arrivalDates.set(
    //                         res.data
    //                             .filter(
    //                                 (x) =>
    //                                     x.key.toLowerCase() ===
    //                                     'complemintarycheckin' ||
    //                                     x.key.toLowerCase() ===
    //                                     'forpurchasecheckin'
    //                             )
    //                             .map((y) =>
    //                                 Helper.FormatDate(
    //                                     moment(y.description).format()
    //                                 )
    //                             )
    //                     );
    //                     departureDates.set(
    //                         res.data
    //                             .filter(
    //                                 (x) =>
    //                                     x.key.toLowerCase() ===
    //                                     'complimentarycheckout'
    //                             )
    //                             .map((y) =>
    //                                 Helper.FormatDate(
    //                                     moment(y.description).format()
    //                                 )
    //                             )
    //                     );
    //                 }
    //             }
    //         })
    //         .catch((err) =>
    //         {
    //             console.log(err);
    //         });
    // };
    // const fetchEventConfig = async (id) => {
   
    //     if (participant && participant.userTags === null) {
    //         return;
    //     }
    //     const gEventInfo = Helper.getStorage('eventInfo');
    //     const eventID = gEventInfo.eventID
    //     const moduleID = 1;
    //     const tagID = id
    //     let tags =
    //         participant &&
    //         participant.userTags !== null &&
    //         participant.userTags.split(',');
    //     let checkInDates = null;
    //     let checkOutDates = null;

    //     if (tags && tags.length > 0) {
    //         await ApiHelper.get(
    //             APIURLConstants.GET_TRANSPORT_DATE_SETTING(gEventInfo.eventID)
    //         ).then(async(res) => {
    //             if (res.data) {
    //           await  ApiHelper.get(
    //                     APIURLConstants.GET_EVENT_TAG_DATES(eventID, moduleID, tagID)
    //                 )
    //                     .then((res) => {
    //                         if (res.data.length > 0) {
    //                             const data = res.data;
    //                             if (arrivalInfo.arrivalDate) {
    //                                 setDateDisabled(false)
    //                                 let minDates = [];
    //                                 let maxDates = [];
    //                                 let fromDate = [];
    //                                 let toDate = [];
            
    //                                 data.forEach((item) => {
    //                                     const types = item.type === 1 ? 'Fixed' : 'Range';
    //                                     if (types === 'Range') {
    //                                         const fromDate = item.fromDate;
    //                                         const toDate = item.toDate;
            
    //                                         minDates.push(fromDate);
    //                                         maxDates.push(toDate);
    //                                     } else if (types === 'Fixed') {
    //                                         fromDate.push(item.fromDate);
    //                                         toDate.push(item.toDate);
    //                                     }
    //                                 });
    //                                 setfromDates(fromDate);
    //                                 settoDates(toDate);
    //                                 setminDate(minDates);
    //                                 setMaxDate(maxDates);
    //                             }
    //                         }
    //                     })



    //                 tags.map((tag) => {
    //                     res.data.map((val) => {
    //                         if (tag.trim() === val.tagName) {
    //                             checkInDates = new Date(val.checkinDate);
    //                             checkOutDates =
    //                                 val.checkoutDate === '0001-01-01T00:00:00'
    //                                     ? null
    //                                     : new Date(val.checkoutDate);
    //                         }
    //                         // else {
    //                         //     checkInDates = null;
    //                         //     checkOutDates = null;
    //                         // }
    //                     });
    //                 });
    //             }

    //             setDate({
    //                 arrivalDate: checkInDates,
    //                 departureDate: checkOutDates,
    //             });
    //         });
    //     } else {
    //         arrivalState.set({
    //             ...arrivalState.get(),
    //             arrivalDate: null,
    //         });
    //         departureState.set({
    //             ...departureState.get(),
    //             departureDate: null,
    //         });
    //     }
    // };
    const fetchEventConfig = async (id) => {
        const gEventInfo = Helper.getStorage('eventInfo');
        const eventID = gEventInfo.eventID
        const moduleID = 1;
        const tagID = id.map((val) => val.trim())

        await ApiHelper.get(
            APIURLConstants.GET_EVENT_TAG_DATES(eventID, moduleID, tagID)
        )
            .then((res) => {
                if (res.data.length > 0) {
                    const data = res.data;
                    if (arrivalInfo.arrivalDate) {
                        setDateDisabled(false)
                        let minDates = [];
                        let maxDates = [];
                        let fromDate = [];
                        let toDate = [];

                        data.forEach((item) => {
                            const types = item.type === 1 ? 'Fixed' : 'Range';
                            if (types === 'Range') {
                                const fromDate = item.fromDate;
                                const toDate = item.toDate;

                                minDates.push(fromDate);
                                maxDates.push(toDate);
                            } else if (types === 'Fixed') {
                                fromDate.push(item.fromDate);
                                toDate.push(item.toDate);
                            }
                            else{
                                setdisableallDates(true);
                               }
                        });
                        setfromDates(fromDate);
                        settoDates(toDate);
                        setminDate(minDates);
                        setMaxDate(maxDates);
                    }
                    //   if(departureInfo.departureDate){
                    //   let minDates = null;
                    //   let maxDates = null;
                    //   const datesrange = null;

                    //   data.forEach((item,index) => {
                    //     const types = item.type === 1 ? 'Fixed': 'Range'
                    //     if(types === 'Fixed' ){
                    //     const fromDate = item.fromDate;
                    //     const toDate = item.toDate;

                    //     minDates=fromDate;
                    //     maxDates=toDate;
                    //     }
                    //     else if(types === 'Range'){

                    //     datesrange = [...item.fromDate,...item.toDate]
                    //     }
                    //   });

                    //   setminDate(minDates);
                    //   setMaxDate(maxDates);
                    // }
                } else {
                    setdisableallDates(true);
                    setDateDisabled(false)
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };
    useEffect(() => {
        if (date.arrivalDate || date.departureDate) {
            console.log(date.arrivalDate);
            console.log(date.departureDate);

            if (tripType.get() === 'round') {
                arrivalState.set({
                    ...arrivalState.get(),
                    arrivalDate: date.arrivalDate,
                });
                departureState.set({
                    ...departureState.get(),
                    departureDate: date.departureDate,
                });
            } else {
                arrivalState.set({
                    ...arrivalState.get(),
                    arrivalDate: date.arrivalDate,
                    // checkOutDate: checkOutDates,
                });
            }
        }
    }, [date]);
    

    useEffect(() => {
        const gEventInfo = Helper.getStorage('eventInfo');
        const gUserInfo = Helper.getStorage('userInfo');
        // fetchEventConfig(gEventInfo.eventID);
        originalBusinessTickets.set(props.originalBusinessTickets);
        originalEconomyTickets.set(props.originalEconomyTickets);

        totalBusinessTickets.set(props.totalBusinessTickets);
        totalEconomyTickets.set(props.totalEconomyTickets);
        remainingArrivalBusinessTickets.set(
            props.remainingArrivalBusinessTickets
        );
        remainingArrivalEconomyTickets.set(
            props.remainingArrivalEconomyTickets
        );
        remainingDepartureBusinessTickets.set(
            props.remainingDepartureBusinessTickets
        );
        remainingDepartureEconomyTickets.set(
            props.remainingDepartureEconomyTickets
        );

        eventInfo.set(gEventInfo);
        userInfo.set(gUserInfo);

        if (props && props.transitID == 0) {
            tripType.set('round');
            if (
                !Helper.isAdminUser(gUserInfo) &&
                !Helper.isEventAdmin(gUserInfo)
            )
            {
            getParticipantDob(
                agentState.visible.value
                    ? agentState.user.get() && agentState.user.get().userID
                    : gUserInfo.userID
            );
             }
        }
    }, []);
    // const isDateDisable = (type, date) =>
    // {
    //     if (
    //         configDetails
    //             .attach(Downgraded)
    //             .get()
    //             .find((x) => x.key.toLowerCase() === 'complemintarycheckin')
    //     )
    //     {
    //         if (type === 'arrival')
    //         {
    //             if (
    //                 arrivalDates
    //                     .attach(Downgraded)
    //                     .get()
    //                     .includes(Helper.FormatDate(moment(date).format()))
    //             )
    //             {
    //                 return false;
    //             }
    //             return true;
    //         } else if (type === 'departure')
    //         {
    //             if (
    //                 departureDates
    //                     .attach(Downgraded)
    //                     .get()
    //                     .includes(Helper.FormatDate(moment(date).format()))
    //             )
    //             {
    //                 return false;
    //             }
    //             return true;
    //         }
    //     }
    //     return false;
    // };
    const resetState = () => {
        departureState.set({
            draftCombineTransportID: 0,
            draftCombineAirTransportID: 0,
            eventID: eventInfo.eventID.value,
            transportType: 'air',
            tripInfoType: 'departure',
            //participantType: participantType.get(),
            isPrivate: '',
            totalPassengers: 1,
            ticketType: 0,
            peopleInfo: [
                {
                    name: '',
                    dob: null,
                },
                {
                    name: '',
                    dob: null,
                },
            ],
            departureAirport: '',
            arrivalAirport: '',
            departureDate: null,
            departureTime: null,
            arrivalDate: null,
            arrivalTime: null,
            departureAirline: '',
            departureFlightNo: '',
            departureComments: '',
            createdBy: userInfo.userID.value,
            // addedFor
            addedFor: userInfo.userID.value,
        });
        arrivalState.set({
            draftCombineTransportID: 0,
            draftCombineAirTransportID: 0,
            eventID: eventInfo.eventID.value,
            transportType: 'air',
            tripInfoType: 'arrival',
            //participantType: participantType.get(),
            isPrivate: false,
            totalPassengers: 1,
            ticketType: 0,
            peopleInfo: [
                {
                    name: '',
                    dob: null,
                },
                {
                    name: '',
                    dob: null,
                },
            ],
            departureAirport: '',
            arrivalAirport: '',
            arrivalDate: null,
            arrivalTime: null,
            departureDate: null,
            departureTime: null,
            arrivalAirline: '',
            arrivalFlightNo: '',
            arrivalComments: '',
            createdBy: userInfo.userID.value,
            // addedFor
            addedFor: userInfo.userID.value,
        });
    };
    // const SETEmailNotification = async (ObjRequest, id) =>
    // {
    //     let obj = Object.assign({}, ObjRequest);
    //     let form = new FormData();

    //     if (obj.arrivalInfo)
    //     {
    //         form.append('UserID', obj.arrivalInfo?.addedFor);
    //         form.append('EventID', obj.arrivalInfo?.eventID)
    //         form.append('TemplateType', 'CombineTransportationAir')
    //         form.append('ID', id)
    //         form.append('ModifyBy', obj.arrivalInfo?.createdBy)
    //         form.append('TranportType', 'arrival')
    //         form.append('ModuleID', 21)
    //         // delete obj.arrivalInfo?.requestStatus;
    //     } else if (obj.departureInfo)
    //     {
    //         form.append('UserID', obj.departureInfo.addedFor);
    //         form.append('EventID', obj.departureInfo.eventID)
    //         form.append('TemplateType', 'CombineTransportationAir')
    //         form.append('ID', id)
    //         form.append('ModifyBy', obj.departureInfo.createdBy)
    //         form.append('TranportType', 'departure')
    //         form.append('ModuleID', 21)
    //         // delete obj.departureInfo?.requestStatus;
    //     }
    //     return await ApiHelper.post(
    //         APIURLConstants.POST_EMAIL_NOTIFICATION,
    //         form
    //     )
    //         .then((result) =>
    //         {
    //             return result.data;
    //         })
    //         .catch((err) =>
    //         {
    //             console.log(err);
    //         });
    // };

    // const SETEmailNotification = (ObjRequest) => {
    //     let obj = Object.assign({}, ObjRequest);
    //     if (obj.arrivalInfo) {
    //         delete obj.arrivalInfo?.requestStatus;
    //     } else if (obj.departureInfo) {
    //         delete obj.departureInfo?.requestStatus;
    //     }
    //     ApiHelper.post(
    //         APIURLConstants.POST_SET_COMBINE_AIR_EMAIL_NOTIFICATION,
    //         obj
    //     )
    //         .then((result) => {
    //             console.log(result.data);
    //         })
    //         .catch((err) => {
    //             console.log(err);
    //         });
    // };
    const getParticipantList = () => {
        const gEventInfo = Helper.getStorage('eventInfo');
        ApiHelper.get(
            APIURLConstants.GET_ADMIN_EVENT_PARTICIPANTS(gEventInfo.eventID)
        ).then((res) => {
            if (res.data.rows) {
                const participants = res.data.rows.filter(
                    (participant) =>
                        AppConstants.EVENT_ROLES_VALUES.indexOf(
                            participant.roleName
                        ) == -1
                );
                setAllParticipantList(participants);
                let userid =  agentState.visible.value
                ? agentState.user.get() && agentState.user.get().userID
                : userInfo.userID.value;
                if (userInfo && userid) {
                    const index = participants.findIndex(
                        (user) => user.userID === userid
                    );

                    if (index > -1) {
                        props && props.transitID != 0
                            ? null
                            : fetchEventConfig(participants[index]);
                    }
                }
            }
        });
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        const getTripType = tripType.get();
        const getInfoType = infoType.get();

        arrivalState.createdBy.set(
            agentState.visible.value ? agentInfo.userID : userInfo.userID.value
        );
        departureState.createdBy.set(
            agentState.visible.value ? agentInfo.userID : userInfo.userID.value
        );

        arrivalState.addedFor.set(
            agentState.visible.value
                ? agentState.user.get() && agentState.user.get().userID
                : userInfo.userID.value
        );
        departureState.addedFor.set(
            agentState.visible.value
                ? agentState.user.get() && agentState.user.get().userID
                : userInfo.userID.value
        );

        // this will be changed as per selected user
        // const addedFor = participant
        //     ? participant.userID
        //     : userInfo.userID.value;
        // arrivalState.addedFor.set(addedFor);
        // departureState.addedFor.set(addedFor);
        // console.log(Helper.isEventAdmin(userInfo.get()))
        if (
            Helper.isAdminUser(userInfo.get()) ||
            (userInfo.get().roles && Helper.isEventAdmin(userInfo.get())) ||
            Helper.isEventStaff(userInfo.get())
        ) {
            if (participant === null) {
                props.setSnackBarProps({
                    ...props.snackBarProps,
                    openSnack: true,
                    variant: 'error',
                    message: 'please Select participant First',
                });
                return;
            }
        }

        arrivalState.addedFor.set(
            participant
                ? participant.userID
                : arrivalState.addedFor.get()
                ? arrivalState.addedFor.get()
                : userInfo.userID.value
        );
        // arrivalState.ticketType.set(arrivalState.ticketType.get() == 'Business' ? 1 : 2)

        departureState.addedFor.set(
            participant
                ? participant.userID
                : departureState.addedFor.get()
                ? departureState.addedFor.get()
                : userInfo.userID.value
        );
        //departureState.ticketType.set(arrivalState.ticketType.get() == 'Business' ? 1 : 2)

        let requestObj = {};
        

        let arrivalInfo = setInfo(
            arrivalState,
            'arrivalDate',
            'arrivalTime',
            'departureDate',
            'departureTime'
        );
        let departureInfo = setInfo(
            departureState,
            'arrivalDate',
            'arrivalTime',
            'departureDate',
            'departureTime'
        );

        if (props.transitID) {
            // if (
            //     infoType.get() === 'arrival' &&
            //     new Date(arrivalState.arrivalDate.get()) <
            //     new Date(arrivalState.departureDate.get())
            // )
            // {
            //     props.setSnackBarProps({
            //         ...props.snackBarProps,
            //         openSnack: true,
            //         variant: 'error',
            //         message:
            //             'Arrival date should be equal to or greater than departure date',
            //     });
            //     return false;
            // } else if (
            //     infoType.get() === 'departure' &&
            //     new Date(departureState.arrivalDate.get()) <
            //     new Date(departureState.departureDate.get())
            // )
            // {
            //     props.setSnackBarProps({
            //         ...props.snackBarProps,
            //         openSnack: true,
            //         variant: 'error',
            //         message:
            //             'Arrival date should be equal to or greater than departure date',
            //     });
            //     return false;
            // } else
            if (
                infoType.get() === 'departure' &&
                !Helper.onlyLettersAndSpacesWithHyphensAndDot(
                    departureState.get().peopleInfo[0].name
                )
            ) {
                arrivalState['peopleInfo'][0]['err'].set(
                    'Please Enter Valid Person Name'
                );
                return false;
            } else if (
                infoType.get() === 'arrival' &&
                !Helper.onlyLettersAndSpacesWithHyphensAndDot(
                    arrivalState.get().peopleInfo[0].name
                )
            ) {
                arrivalState['peopleInfo'][0]['err'].set(
                    'Please Enter Valid Person Name'
                );
                return false;
            }
            else if (
                infoType.get() === 'arrival' &&
                (arrivalState.attach(Downgraded).get().arrivalTime === null || arrivalState.attach(Downgraded).get().arrivalTime === '')
            )
            {
                props.setSnackBarProps({
                    ...props.snackBarProps,
                    openSnack: true,
                    variant: 'error',
                    message: 'Please select arrival time.',
                });
                return false;
            }
            else if (
                infoType.get() === 'departure' &&
                (departureState.attach(Downgraded).get().departureTime ===
                    null ||
                    departureState.attach(Downgraded).get().departureTime ===
                        '')
            ) {
                props.setSnackBarProps({
                    ...props.snackBarProps,
                    openSnack: true,
                    variant: 'error',
                    message: 'Please select departure time',
                });
                return false;
            }
            else if( infoType.get() === 'arrival' && 
                        (arrivalState.contactNo.get() === null ||  arrivalState.contactNo.get() === "" ||  arrivalState.contactNo.get() == "+1")
            ) {
                // setShowLoading(false);
                props.setSnackBarProps({
                    ...props.snackBarProps,
                    openSnack: true,
                    variant: 'error',
                    message: 'Please Enter Contact No.',
                });
                return false;
            }  else if( infoType.get() === 'departure' && 
                (departureState.contactNo.get() === null ||  departureState.contactNo.get() === "" ||  departureState.contactNo.get() == "+1")
            ) {
                // setShowLoading(false);
                props.setSnackBarProps({
                    ...props.snackBarProps,
                    openSnack: true,
                    variant: 'error',
                    message: 'Please Enter Contact No.',
                });
                return false;
            }
        } else {
            if (tripType.get() === 'round') {
                // console.log(typeof arrivalState.arrivalTime.get(),arrivalState.arrivalTime.get() !== null ? "tere": "21234234");
                if (
                    arrivalState.arrivalDate.get() === null ||
                    // arrivalState.departureDate.get() === null ||
                    // departureState.arrivalDate.get() === null ||
                    departureState.departureDate.get() === null
                ) {
                    props.setSnackBarProps({
                        ...props.snackBarProps,
                        openSnack: true,
                        variant: 'error',
                        message: 'Please select dates.',
                    });
                    return false;
                }
                if (
                    arrivalState.contactNo.get() === null ||  arrivalState.contactNo.get() === "" ||  arrivalState.contactNo.get() === "+1" ||
                    departureState.contactNo.get() === null || departureState.contactNo.get() === "" ||  departureState.contactNo.get() === "+1"
                ) {
                    // setShowLoading(false);
                    props.setSnackBarProps({
                        ...props.snackBarProps,
                        openSnack: true,
                        variant: 'error',
                        message: 'Please Enter Contact No.',
                    });
                    return false;
                }
                if (
                    !Helper.onlyLettersAndSpacesWithHyphensAndDot(
                        arrivalState.get().peopleInfo[0].name
                    )
                ) {
                    arrivalState['peopleInfo'][0]['err'].set(
                        'Please Enter Valid Person Name'
                    );
                    return false;
                }

                // if (
                //     (arrivalState.attach(Downgraded).get() &&
                //         new Date(
                //             arrivalState.attach(Downgraded).get().arrivalDate
                //         ) <
                //         new Date(
                //             arrivalState
                //                 .attach(Downgraded)
                //                 .get().departureDate
                //         )) ||
                //     (departureState.attach(Downgraded).get() &&
                //         new Date(
                //             departureState.attach(Downgraded).get().arrivalDate
                //         ) <
                //         new Date(
                //             departureState
                //                 .attach(Downgraded)
                //                 .get().departureDate
                //         ))
                // )
                // {
                //     props.setSnackBarProps({
                //         ...props.snackBarProps,
                //         openSnack: true,
                //         variant: 'error',
                //         message:
                //             'Arrival date should be equal to or greater than departure date',
                //     });
                //     return false;
                // }

                if (
                    tripType.get() === 'round' &&
                    departureState.attach(Downgraded).get().peopleInfo[0][
                        'dob'
                    ] == null
                ) {
                    props.setSnackBarProps({
                        ...props.snackBarProps,
                        openSnack: true,
                        variant: 'error',
                        message: 'Please select DOB',
                    });
                    return false;
                }
                if (
                    tripType.get() === 'round' &&
                    departureState.attach(Downgraded).get().departureDate ==
                        null
                ) {
                    props.setSnackBarProps({
                        ...props.snackBarProps,
                        openSnack: true,
                        variant: 'error',
                        message: 'Please select departure date',
                    });
                    return false;
                }
                if (
                    !(Helper.isAdminUser(userInfo.get()) ||
                    (userInfo.get().roles && Helper.isEventAdmin(userInfo.get())) ||
                    Helper.isEventStaff(userInfo.get()))
                ) {
                    if (
                        tripType.get() === 'round' &&
                        (arrivalUsedCount >= 1 || departureUsedCount >= 1)
                    ) {
                        props.setSnackBarProps({
                            ...props.snackBarProps,
                            openSnack: true,
                            variant: 'error',
                            message:
                                'Arrival and Departure limit exceeds for Round Trip!',
                        });
                        return false;
                    }
                }
                // if (
                //     tripType.get() === 'round' &&
                //     departureState.attach(Downgraded).get().arrivalDate == null
                // )
                // {
                //     props.setSnackBarProps({
                //         ...props.snackBarProps,
                //         openSnack: true,
                //         variant: 'error',
                //         message: 'Please select arrival date',
                //     });
                //     return false;
                // }

                // if (
                //     infoType.get() === 'round' &&
                //     arrivalState.attach(Downgraded).get().departureDate == null
                // )
                // {
                //     props.setSnackBarProps({
                //         ...props.snackBarProps,
                //         openSnack: true,
                //         variant: 'error',
                //         message: 'Please select departure date',
                //     });
                //     return false;
                // }
                // if (arrivalState.attach(Downgraded).get().departureTime === null || arrivalState.attach(Downgraded).get().departureTime === '')
                // {
                //     props.setSnackBarProps({
                //         ...props.snackBarProps,
                //         openSnack: true,
                //         variant: 'error',
                //         message:
                //             'Please select departure time',
                //     });
                //     return false;
                // }
                if (
                    arrivalState.attach(Downgraded).get().arrivalTime ===
                        null ||
                    arrivalState.attach(Downgraded).get().arrivalTime === ''
                ) {
                    props.setSnackBarProps({
                        ...props.snackBarProps,
                        openSnack: true,
                        variant: 'error',
                        message: 'Please select arrival time',
                    });
                    return false;
                }

                if (
                    departureState.attach(Downgraded).get().departureTime ===
                        null ||
                    departureState.attach(Downgraded).get().departureTime === ''
                ) {
                    props.setSnackBarProps({
                        ...props.snackBarProps,
                        openSnack: true,
                        variant: 'error',
                        message: 'Please select departure time',
                    });
                    return false;
                }
                // if (departureState.attach(Downgraded).get().arrivalTime === null || departureState.attach(Downgraded).get().arrivalTime === '')
                // {
                //     props.setSnackBarProps({
                //         ...props.snackBarProps,
                //         openSnack: true,
                //         variant: 'error',
                //         message:
                //             'Please select arrival time',
                //     });
                //     return false;
                // }
            } else if (tripType.get() === 'oneway') {
                if (infoType.get() === 'arrival') {
                    if (
                        arrivalState.arrivalDate.get() === null
                        // || arrivalState.departureDate.get() === null
                    ) {
                        props.setSnackBarProps({
                            ...props.snackBarProps,
                            openSnack: true,
                            variant: 'error',
                            message: 'Please select arrival date.',
                        });
                        return false;
                    }
                    if (
                        arrivalState.contactNo.get() === null ||  arrivalState.contactNo.get() === "" ||  arrivalState.contactNo.get() == "+1"
                    ) {
                        // setShowLoading(false);
                        props.setSnackBarProps({
                            ...props.snackBarProps,
                            openSnack: true,
                            variant: 'error',
                            message: 'Please Enter Contact No.',
                        });
                        return false;
                    }
                    // if (
                    //     arrivalState.attach(Downgraded).get() &&
                    //     new Date(
                    //         arrivalState.attach(Downgraded).get().arrivalDate
                    //     ) <
                    //     new Date(
                    //         arrivalState
                    //             .attach(Downgraded)
                    //             .get().departureDate
                    //     )
                    // )
                    // {
                    //     props.setSnackBarProps({
                    //         ...props.snackBarProps,
                    //         openSnack: true,
                    //         variant: 'error',
                    //         message:
                    //             'Arrival date should be equal to or greater than departure date',
                    //     });
                    //     return false;
                    // }
                    if (
                        infoType.get() === 'arrival' &&
                        arrivalState.attach(Downgraded).get().peopleInfo[0][
                            'dob'
                        ] == null
                    ) {
                        props.setSnackBarProps({
                            ...props.snackBarProps,
                            openSnack: true,
                            variant: 'error',
                            message: 'Please select DOB',
                        });
                        return false;
                    }
                    if (
                        infoType.get() === 'arrival' &&
                        arrivalState.attach(Downgraded).get().arrivalDate ==
                            null
                    ) {
                        props.setSnackBarProps({
                            ...props.snackBarProps,
                            openSnack: true,
                            variant: 'error',
                            message: 'Please select arrival date',
                        });
                        return false;
                    }
                    if (
                        infoType.get() === 'arrival' &&
                        (arrivalState.attach(Downgraded).get().arrivalTime ==
                            null ||
                            arrivalState.attach(Downgraded).get().arrivalTime ==
                                '')
                    ) {
                        props.setSnackBarProps({
                            ...props.snackBarProps,
                            openSnack: true,
                            variant: 'error',
                            message: 'Please select arrival time',
                        });
                        return false;
                    }
                    if (
                        !(Helper.isAdminUser(userInfo.get()) ||
                        (userInfo.get().roles && Helper.isEventAdmin(userInfo.get())) ||
                        Helper.isEventStaff(userInfo.get()))
                    ) {
                        if (infoType.get() === 'arrival' && arrivalUsedCount >= 1) {
                            props.setSnackBarProps({
                                ...props.snackBarProps,
                                openSnack: true,
                                variant: 'error',
                                message: 'Arrival limit exceeds!',
                            });
                            return false;
                        }
                    }
                }
                if (infoType.get() === 'departure') {
                    if (
                        // departureState.arrivalDate.get() === null ||
                        departureState.departureDate.get() === null
                    ) {
                        props.setSnackBarProps({
                            ...props.snackBarProps,
                            openSnack: true,
                            variant: 'error',
                            message: 'Please select departure dates.',
                        });
                        return false;
                    }
                    if (
                        departureState.contactNo.get() === null ||  departureState.contactNo.get() === "" ||  departureState.contactNo.get() === "+1" 
                    ) {
                        // setShowLoading(false);
                        props.setSnackBarProps({
                            ...props.snackBarProps,
                            openSnack: true,
                            variant: 'error',
                            message: 'Please Enter Contact No.',
                        });
                        return false;
                    }
                    // if (
                    //     departureState.attach(Downgraded).get() &&
                    //     new Date(
                    //         departureState.attach(Downgraded).get().arrivalDate
                    //     ) <
                    //     new Date(
                    //         departureState
                    //             .attach(Downgraded)
                    //             .get().departureDate
                    //     )
                    // )
                    // {
                    //     props.setSnackBarProps({
                    //         ...props.snackBarProps,
                    //         openSnack: true,
                    //         variant: 'error',
                    //         message:
                    //             'Arrival date should be equal to or greater than departure date',
                    //     });
                    //     return false;
                    // }
                    if (
                        infoType.get() === 'departure' &&
                        departureState.attach(Downgraded).get().peopleInfo[0][
                            'dob'
                        ] == null
                    ) {
                        props.setSnackBarProps({
                            ...props.snackBarProps,
                            openSnack: true,
                            variant: 'error',
                            message: 'Please select DOB',
                        });
                        return false;
                    }
                    if (
                        infoType.get() === 'departure' &&
                        departureState.attach(Downgraded).get().departureDate ==
                            null
                    ) {
                        props.setSnackBarProps({
                            ...props.snackBarProps,
                            openSnack: true,
                            variant: 'error',
                            message: 'Please select departure date',
                        });
                        return false;
                    }
                    if (
                        !(Helper.isAdminUser(userInfo.get()) ||
                        (userInfo.get().roles && Helper.isEventAdmin(userInfo.get())) ||
                        Helper.isEventStaff(userInfo.get()))
                    ) {
                        if (
                            infoType.get() === 'departure' &&
                            departureUsedCount >= 1
                        ) {
                            props.setSnackBarProps({
                                ...props.snackBarProps,
                                openSnack: true,
                                variant: 'error',
                                message: 'Departure limit exceeds!',
                            });
                            return false;
                        }
                    }
                    if (
                        infoType.get() === 'departure' &&
                        (departureState.attach(Downgraded).get()
                            .departureTime === null ||
                            departureState.attach(Downgraded).get()
                                .departureTime === '')
                    ) {
                        props.setSnackBarProps({
                            ...props.snackBarProps,
                            openSnack: true,
                            variant: 'error',
                            message: 'Please select departure time',
                        });
                        return false;
                    }
                }
            }
        }

        if (getTripType == 'round') {
            if (
                arrivalState.arrivalDate.get() === null ||
                // arrivalState.departureDate.get() === null ||
                // departureState.arrivalDate.get() === null
                departureState.departureDate.get() === null
            ) {
                props.setSnackBarProps({
                    ...props.snackBarProps,
                    openSnack: true,
                    variant: 'error',
                    message: 'Please select dates.',
                });
                return false;
            }
            arrivalInfo.eventID = eventInfo.eventID.value;
            arrivalInfo = Helper.trimObject(arrivalInfo);
            if (arrivalInfo.departureAirport == arrivalInfo.arrivalAirport) {
                props.setSnackBarProps({
                    ...props.snackBarProps,
                    openSnack: true,
                    variant: 'error',
                    message:
                        'Arrival and departure airport should be different',
                });
                return false;
            }

            requestObj.arrivalInfo = arrivalInfo;
            requestObj.arrivalInfo.airline = arrivalInfo.arrivalAirline;
            requestObj.arrivalInfo.flightNo = arrivalInfo.arrivalFlightNo;
            requestObj.arrivalInfo.comments = arrivalInfo.arrivalComments;
            requestObj.arrivalInfo.ticketType = 1;

            departureInfo.eventID = eventInfo.eventID.value;
            departureInfo = Helper.trimObject(departureInfo);
            if (
                departureInfo.departureAirport == departureInfo.arrivalAirport
            ) {
                props.setSnackBarProps({
                    ...props.snackBarProps,
                    openSnack: true,
                    variant: 'error',
                    message:
                        'Arrival and departure airport should be different',
                });
                return false;
            }
            requestObj.departureInfo = departureInfo;
            requestObj.departureInfo.airline = departureInfo.departureAirline;
            requestObj.departureInfo.flightNo = departureInfo.departureFlightNo;
            requestObj.departureInfo.comments = departureInfo.departureComments;
            requestObj.departureInfo.ticketType = 1;

            //requestObj.departureInfo.participantType = participantType.get();
        } else {
            if (getInfoType === 'arrival') {
                // let arrivalInfo = setInfo(
                //     arrivalState,
                //     'arrivalDate',
                //     'arrivalTime',
                //     'departureDate',
                //     'departureTime'
                // );
                if (
                    arrivalState.arrivalDate.get() === null
                    // || arrivalState.departureDate.get() === null
                ) {
                    props.setSnackBarProps({
                        ...props.snackBarProps,
                        openSnack: true,
                        variant: 'error',
                        message: 'Please select dates.',
                    });
                    return false;
                }
                arrivalInfo.eventID = eventInfo.eventID.value;
                arrivalInfo = Helper.trimObject(arrivalInfo);
                if (
                    arrivalInfo.departureAirport == arrivalInfo.arrivalAirport
                ) {
                    props.setSnackBarProps({
                        ...props.snackBarProps,
                        openSnack: true,
                        variant: 'error',
                        message:
                            'Arrival and departure airport should be different',
                    });
                    return false;
                }

                if (arrivalInfo.totalPassengers === 1) {
                    arrivalInfo.peopleInfo = [arrivalInfo.peopleInfo[0]];
                }


                if (departureInfo.totalPassengers === 1) {
                    departureInfo.peopleInfo = [departureInfo.peopleInfo[0]];
                }
                
                requestObj.arrivalInfo = arrivalInfo;
                requestObj.arrivalInfo.airline = arrivalInfo.arrivalAirline;
                requestObj.arrivalInfo.flightNo = arrivalInfo.arrivalFlightNo;
                requestObj.arrivalInfo.comments = arrivalInfo.arrivalComments;
                requestObj.arrivalInfo.ticketType = 1;

                //requestObj.arrivalInfo.participantType = participantType.get()
            } else {
                // let departureInfo = setInfo(
                //     departureState,
                //     'arrivalDate',
                //     'arrivalTime',
                //     'departureDate',
                //     'departureTime'
                // );
                if (
                    // departureState.arrivalDate.get() === null ||
                    departureState.departureDate.get() === null
                ) {
                    props.setSnackBarProps({
                        ...props.snackBarProps,
                        openSnack: true,
                        variant: 'error',
                        message: 'Please select dates.',
                    });
                    return false;
                }
                departureInfo.eventID = eventInfo.eventID.value;
                departureInfo = Helper.trimObject(departureInfo);
                if (
                    departureInfo.departureAirport ==
                    departureInfo.arrivalAirport
                ) {
                    props.setSnackBarProps({
                        ...props.snackBarProps,
                        openSnack: true,
                        variant: 'error',
                        message:
                            'Arrival and departure airport should be different',
                    });
                    return false;
                }

                requestObj.departureInfo = departureInfo;
                requestObj.departureInfo.airline =
                    departureInfo.departureAirline;
                requestObj.departureInfo.flightNo =
                    departureInfo.departureFlightNo;
                requestObj.departureInfo.comments =
                    departureInfo.departureComments;
                requestObj.departureInfo.ticketType = 1;
            }
        }    
        
       
        // console.log("arrivalUsedCount", arrivalUsedCount, departureUsedCount)
        if (
            currentTransportInfo.get() &&
            currentTransportInfo.get().draftCombineTransportID > 0
        ) {
            var tempRequestObject = Object.assign({}, requestObj);
            requestObj.transportInfo =
                requestObj.departureInfo || requestObj.arrivalInfo;
            delete requestObj.arrivalInfo;
            delete requestObj.departureInfo;
            disableButton.set(true);
            ApiHelper.post(
                APIURLConstants.POST_UPD_DRAFT_COMBINE_AIR_TRANSPORT,
                requestObj
            )
                .then(async (res) => {
                    if (res.data) {
                        props.setSnackBarProps({
                            ...props.snackBarProps,
                            openSnack: true,
                            variant: 'success',
                            message: 'Request updated successfully',
                        });
                        // let isPublished = allParticipantList.filter(
                        //     (x) =>
                        //         x.isPublished === true &&
                        //         x.userID === requestObj.transportInfo.addedFor
                        // );
                        // if (isPublished.length > 0) {
                        //     SETEmailNotification(tempRequestObject);
                        // }
                        updateModuleState();
                        setTimeout(async () => {
                            resetState();
                            disableButton.set(false);
                            if (
                                Helper.isAdminUser(userInfo.get()) ||
                                (userInfo.get().roles &&
                                    Helper.isEventAdmin(userInfo.get())) ||
                                (userInfo.get().roles &&
                                    Helper.isEventStaff(userInfo.get()))
                            ) {
                                // props.history.push(
                                //     generatePath(
                                //         RouteConstants.EVENT_TRANSIT_LIST,
                                //         { eventID: eventInfo.eventID.value }
                                //     )
                                // );
                                props.history.goBack();
                            } else {
                                props.history.push(
                                    generatePath(
                                        RouteConstants.DRAFT_COMBINE_EVENT_TRANSIT,
                                        {
                                            eventID: eventInfo.eventID.value,
                                        }
                                    )
                                );
                            }
                        }, 1000);
                    }
                })
                .catch((error) => {

                    disableButton.set(false);
                    if (error.response && error.response.status === 401) {
                        props.setSnackBarProps({
                            ...props.snackBarProps,
                            openSnack: true,
                            variant: 'error',
                            message: 'Access denied',
                        });
                    } else {
                        props.setSnackBarProps({
                            ...props.snackBarProps,
                            openSnack: true,
                            variant: 'error',
                            message: 'Error while creating request',
                        });
                    }
                });
        } else {
            disableButton.set(true);
            ApiHelper.post(
                APIURLConstants.POST_INS_DRAFT_COMBINE_AIR_TRANSPORT,
                requestObj
            )
                .then(async (res) => {
                    if (res.data) {
                        props.setSnackBarProps({
                            ...props.snackBarProps,
                            openSnack: true,
                            variant: 'success',
                            message: 'Request added successfully',
                        });
                        // let isPublished = allParticipantList.filter(
                        //     (x) =>
                        //         x.isPublished === true &&
                        //         x.userID ===
                        //             (getInfoType === 'arrival'
                        //                 ? requestObj.arrivalInfo.addedFor
                        //                 : requestObj.departureInfo.addedFor)
                        // );
                        // if (isPublished.length > 0) {
                        //     SETEmailNotification(requestObj);
                        // }
                        updateModuleState();
                        setTimeout(() => {
                            resetState();
                            disableButton.set(false);
                            if (
                                Helper.isAdminUser(userInfo.get()) ||
                                (userInfo.get().roles &&
                                    Helper.isEventAdmin(userInfo.get())) ||
                                (userInfo.get().roles &&
                                    Helper.isEventStaff(userInfo.get()))
                            ) {
                                props.history.push(
                                    generatePath(
                                        RouteConstants.DRAFT_COMBINE_EVENT_TRANSIT_LIST,
                                        { eventID: eventInfo.eventID.value }
                                    )
                                );
                            } else {
                                props.history.push(
                                    generatePath(
                                        RouteConstants.DRAFT_COMBINE_EVENT_TRANSIT,
                                        {
                                            eventID: eventInfo.eventID.value,
                                        }
                                    )
                                );
                            }
                        }, 2000);
                    }
                })
                .catch((error) => {
                    disableButton.set(false);
                    if (error.response && error.response.status === 401) {
                        props.setSnackBarProps({
                            ...props.snackBarProps,
                            openSnack: true,
                            variant: 'error',
                            message: 'Access denied',
                        });
                    } else {
                        props.setSnackBarProps({
                            ...props.snackBarProps,
                            openSnack: true,
                            variant: 'error',
                            message: 'Error while creating request',
                        });
                    }
                });
        }
    };

    const handleBtnCancel = () => {
        resetState();
        props.history.goBack();
    };

    const handleOnChange2 = (stateobj, field, value, index) => {
// console.log("stateobj, field, value, index",stateobj, field, value, index);
        if(tripType.get() == 'round' || tripType.get() == 'oneway') {
          if(field == 'totalPassengers')
            {
            departureState[field].set(value);
            arrivalState[field].set(value);
            }
        } 
        // arrivalState['departureDate'][index][field].set(value);
        if (field == 'dob') {
            arrivalState['peopleInfo'][index][field].set(
                dayjs(value).format('YYYY-MM-DDTHH:mm:ss')
            );
            if (tripType.get() == 'round') {
                setDateDOBDisabled(true)
            }
            departureState['peopleInfo'][index][field].set(
                dayjs(value).format('YYYY-MM-DDTHH:mm:ss')
            );
        } else if (field == 'departureDate') {
            stateobj[field].set(value);
            // stateobj['departureDate'].set( dayjs(value).format('YYYY-MM-DDTHH:mm'));
            arrivalState['arrivalDate'].set(dayjs(value).format('YYYY-MM-DDTHH:mm'));
            arrivalState['departureDate'].set(dayjs(value).format('YYYY-MM-DDTHH:mm'));
        } else if (field == 'arrivalDate') {
            stateobj[field].set(value);
            // arrivalState[field].set(dayjs(value).format('YYYY-MM-DDTHH:mm'));
            departureState['arrivalDate'].set(dayjs(value).format('YYYY-MM-DDTHH:mm'));
            departureState['departureDate'].set(dayjs(value).format('YYYY-MM-DDTHH:mm'));
            // departureState[field].set(dayjs(value).format('YYYY-MM-DDTHH:mm'));
            // stateobj['arrivalDate'].set( dayjs(value).format('YYYY-MM-DDTHH:mm'));
        } else if (field == 'departureTime') {
            stateobj[field].set(value);
            // arrivalState[field].set(value);
            // departureState[field].set(value);
            // stateobj['arrivalDate'].set(value);
        } else if (field == 'arrivalTime') {
            stateobj[field].set(value);
            // arrivalState[field].set(value);
            // departureState[field].set(value);
            // stateobj['arrivalTime'].set(value);
        } else if (field == 'name') {
            stateobj[field].set(value);
            arrivalState['peopleInfo'][index][field].set(value);
            departureState['peopleInfo'][index][field].set(value);
            if (!Helper.onlyLettersAndSpacesWithHyphensAndDot(value)) {
                arrivalState['peopleInfo'][index]['err'].set(
                    'Please Enter Valid Person Name'
                );
                departureState['peopleInfo'][index]['err'].set(
                    'Please Enter Valid Person Name'
                );
            } else {
                arrivalState['peopleInfo'][index]['err'].set('');
                departureState['peopleInfo'][index]['err'].set('');
            }
        }else if(field == 'contactNo'){ 
            arrivalState[field].set(value);
            departureState[field].set(value); 
        } else {
            stateobj[field].set(value);
        }
        handleDisableBtn();
    };
    const getTotalFlightCount = (userID) => {
        const eventInfo = Helper.getStorage('eventInfo');
        const gAgentInfo = Helper.getSessionStorage('agentUser');
        const agentConnection = Helper.getSessionStorage('agentConnections');
        setArrivalUsedCount(0);
        setDepartureUsedCount(0);
        ApiHelper.get(
            APIURLConstants.GET_DRAFT_COMBINE_TRANSPORT_SETTING_BY_USER_ID(
                eventInfo.eventID,
                agentConnection && gAgentInfo ? gAgentInfo.userID : userID
            )
        ).then((res) => {
            if (res.data) {
                res.data.map((count) => {
                    // if (count.setting)
                    // {
                    //     console.log(res.data, arrDeptTotCount);
                    //     const transportSettingData = JSON.parse(count.setting)
                    //     if (transportSettingData)
                    //     {
                    //         const finalSettingData = JSON.parse(transportSettingData[0].TransportSetting)
                    //         setArrDeptTotCount({
                    //             arrival: finalSettingData.arrival,
                    //             departure: finalSettingData.departure
                    //         })
                    //     }
                    // }
                    if (count.usedCounts) {
                        count.usedCounts.map((values) => {
                            // console.log("values",values);
                            if (
                                values.transportType === 'air' &&
                                values.tripInfoType === 'arrival'
                            ) {
                                setArrivalUsedCount(values.usedCount);
                            } else if (
                                values.transportType === 'air' &&
                                values.tripInfoType === 'departure'
                            ) {
                                setDepartureUsedCount(values.usedCount);
                            }
                        });
                    }
                });
            }
        });
    };
    // console.log("userByIDCount",arrivalUsedCount, departureUsedCount);
    const changeParticipant = (participant) => {
        // console.log("participant",participant);
        if (participant) {
            getTotalFlightCount(participant.userID);
            // const [lastName, firstName] = [...participant.name.split(', ')];
            arrivalState.peopleInfo[0]['name'].set('');
            departureState.peopleInfo[0]['name'].set('');

            getParticipantDob(participant.userID);
            // resetState();
        } else {
            // arrivalState.peopleInfo[0]['name'].set('');
            // departureState.peopleInfo[0]['name'].set('');
            arrivalState.peopleInfo[0]['dob'].set(null);
            departureState.peopleInfo[0]['dob'].set(null);
            resetState();
        }
        //fetchEventConfig(participant);
        setParticipant(participant);
    };
    // const handleHotelChange = (e) =>
    // {
    //     let value = e.target.value
    //     if (value === 'Yes')
    //     {
    //         arrivalState.isPrivate.set(true)
    //         departureState.isPrivate.set(true)
    //     }
    //     else
    //     {
    //         arrivalState.isPrivate.set(false)
    //         departureState.isPrivate.set(false)
    //     }
    //     handleDisableBtn()
    // }
    const handleDisableBtn = () => {
        if (props.transitID > 0 && props.transitInfo) {
            const prevState = prevTransInfo.attach(Downgraded).get();
            // console.log("prevState",prevState);
            let prevData = {
                // ticketType: prevState.ticketType,
                totalPassengers: prevState.totalPassengers,
                peopleInfo: prevState.peopleInfo,
                departureAirport: prevState.departureAirport,
                arrivalAirport: prevState.arrivalAirport,
                departureDate: Helper.FormatDateOnly(prevState.departureDate),
                departureTime: Helper.FormatTime24(prevState.departureDate),
                arrivalDate: Helper.FormatDateOnly(prevState.arrivalDate),
                arrivalTime: Helper.FormatTime24(prevState.arrivalDate),
                arrivalAirline: prevState.airline,
                flightNo: prevState.flightNo,
                comments: prevState.comments,
                isPrivate: prevState.isPrivate,
                contactNo: prevState.contactNo
            };

            const transportInfo = props.transitInfo;
            if (transportInfo.tripInfoType === 'arrival') {
                let peopleData = [];
                arrivalState.get().peopleInfo &&
                    arrivalState.get().peopleInfo.map((item) => {
                        let people = {
                            name: item.name,
                            dob: Helper.FormatDateOnly(item.dob),
                        };
                        peopleData.push(people);
                    });

                let currentData = {
                    // ticketType: arrivalState.get().ticketType,
                    totalPassengers: arrivalState.get().totalPassengers,
                    peopleInfo: peopleData,
                    departureAirport: arrivalState.get().departureAirport,
                    arrivalAirport: arrivalState.get().arrivalAirport,
                    departureDate: Helper.FormatDateOnly(
                        arrivalState.get().departureDate
                    ),
                    departureTime: arrivalState.get().departureTime,
                    arrivalDate: Helper.FormatDateOnly(
                        arrivalState.get().arrivalDate
                    ),
                    arrivalTime: arrivalState.get().arrivalTime,
                    arrivalAirline: arrivalState.get().arrivalAirline,
                    flightNo: arrivalState.get().arrivalFlightNo,
                    comments: arrivalState.get().arrivalComments,
                    isPrivate: arrivalState.get().isPrivate,
                    contactNo: arrivalState.get().contactNo
                };
                if (JSON.stringify(prevData) === JSON.stringify(currentData)) {
                    setDisableBtn(true);
                } else {
                    setDisableBtn(false);
                }
            } else {
                let peopleData = [];
                departureState.get().peopleInfo &&
                    departureState.get().peopleInfo.map((item) => {
                        let people = {
                            name: item.name,
                            dob: Helper.FormatDateOnly(item.dob),
                        };
                        peopleData.push(people);
                    });

                let currentData = {
                    // ticketType: departureState.get().ticketType,
                    totalPassengers: departureState.get().totalPassengers,
                    peopleInfo: peopleData,
                    departureAirport: departureState.get().departureAirport,
                    arrivalAirport: departureState.get().arrivalAirport,
                    departureDate: Helper.FormatDateOnly(
                        departureState.get().departureDate
                    ),
                    departureTime: departureState.get().departureTime,
                    arrivalDate: Helper.FormatDateOnly(
                        departureState.get().arrivalDate
                    ),
                    arrivalTime: departureState.get().arrivalTime,
                    arrivalAirline: departureState.get().departureAirline,
                    flightNo: departureState.get().departureFlightNo,
                    comments: departureState.get().departureComments,
                    isPrivate: departureState.get().isPrivate,
                    contactNo: departureState.get().contactNo
                };
                if (JSON.stringify(prevData) === JSON.stringify(currentData)) {
                    setDisableBtn(true);
                } else {
                    setDisableBtn(false);
                }
            }
        }
    };
    // const onSwitchToggle = (event) =>
    // {
    //     setToggle(event.target.checked);
    //     arrivalState.isPrivate.set(event.target.checked);
    //     departureState.isPrivate.set(event.target.checked);
    // };
    // console.log("arrivalState.peopleInfo", Helper.onlyLettersAndSpacesWithHyphens("jacks makay@"));
    const backToListing = () => {
        props.history.goBack();
    };
    // console.log("arrivalUsedCount",arrivalUsedCount);
    return (
        <>
            <Box
                component="form"
                sx={{
                    // p: 2,
                    width: '100%',
                    '& .MuiGrid-item': { p: 1 },
                }}
                onSubmit={handleSubmit}>
                <Card sx={{ boxShadow: 'none' }}>
                    <CardContent classes={{ root: classes.contentRoot }}>
                        <Grid container sx={{ alignItems: 'center' }}>
                            <Grid item lg={8} md={8} xs={12}>
                                <Box className={classes.titleContent}>
                                    <Paper
                                        elevation={0}
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            alignItems: 'center',
                                        }}>
                                         <Box
                                            component="img"
                                            sx={{
                                                    height:'40px',
                                                    width: '40px',
                                            }}
                                            alt="air"
                                            src={airSvg}
                                        />
                                        <Title
                                            title="Air Travel"
                                            sx={{
                                                ml: 1,
                                                fontSize: '30px',
                                            }}
                                        />
                                    </Paper>
                                    <Paper
                                        elevation={0}
                                        className={classes.selectionContent}>
                                        {
                                            <RadioGroup
                                                row
                                                aria-label="tripType"
                                                name="tripType"
                                                value={tripType.get()}
                                                onChange={(event) =>
                                                    tripType.set(
                                                        event.target.value
                                                    )
                                                }>
                                                <FormControlLabel
                                                    value="oneway"
                                                    control={
                                                        <Radio
                                                            color="primary"
                                                            size="small"
                                                        />
                                                    }
                                                    label="One Way"
                                                    disabled={
                                                        props.transitID == 0
                                                            ? false
                                                            : true
                                                    }
                                                />
                                                <FormControlLabel
                                                    value="round"
                                                    control={
                                                        <Radio
                                                            color="primary"
                                                            size="small"
                                                        />
                                                    }
                                                    label="Round Trip"
                                                    disabled={
                                                        props.transitID == 0
                                                            ? false
                                                            : true
                                                    }
                                                />
                                            </RadioGroup>
                                        }
                                        {tripType.get() === 'oneway' ? (
                                            <RadioGroup
                                                row
                                                aria-label="infoType"
                                                name="infoType"
                                                value={infoType.get()}
                                                onChange={(event) => {
                                                    setDateDOBDisabled(false);
                                                    infoType.set(
                                                        event.target.value
                                                    );
                                                }}>
                                                <FormControlLabel
                                                    value="arrival"
                                                    control={
                                                        <Radio
                                                            color="primary"
                                                            size="small"
                                                        />
                                                    }
                                                    label="Arrival Info"
                                                    disabled={
                                                        props.transitID == 0
                                                            ? false
                                                            : true
                                                    }
                                                />
                                                <FormControlLabel
                                                    value="departure"
                                                    control={
                                                        <Radio
                                                            color="primary"
                                                            size="small"
                                                        />
                                                    }
                                                    label="Departure Info"
                                                    disabled={
                                                        props.transitID == 0
                                                            ? false
                                                            : true
                                                    }
                                                />
                                            </RadioGroup>
                                        ) : null}
                                        {/* <RadioGroup
                                            row
                                            // sx={{ ml: 1 }}

                                            onChange={(e) => handleHotelChange(e)}
                                            value={arrivalState.isPrivate.get() ? 'Yes' : departureState.isPrivate.get() ? 'Yes' : 'No'}
                                        >
                                            <FormControlLabel value="Yes" control={<Radio size="small" checked={arrivalState.isPrivate.get() === true || departureState.isPrivate.get() === true} />} label="Private" />
                                            <FormControlLabel value="No" control={<Radio sx={{ ml: 1.6 }} size="small" checked={arrivalState.isPrivate.get() === false || departureState.isPrivate.get() === false} />} label="Commercial" />
                                        </RadioGroup> */}
                                        {/* {
                                            <RadioGroup
                                                row
                                                aria-label="participantType"
                                                name="participantType"
                                                value={participantType.get()}
                                                onChange={(event) =>
                                                    participantType.set(
                                                        event.target.value
                                                    )
                                                }>
                                                <FormControlLabel
                                                    value="Draftee"
                                                    control={
                                                        <Radio
                                                            color="primary"
                                                            size="small"
                                                        />
                                                    }
                                                    label="Draftee"
                                                    disabled={
                                                        props.transitID == 0
                                                            ? false
                                                            : true
                                                    }
                                                />
                                                <FormControlLabel
                                                    value="Guest"
                                                    control={
                                                        <Radio
                                                            color="primary"
                                                            size="small"
                                                        />
                                                    }
                                                    label="Guest"
                                                    disabled={
                                                        props.transitID == 0
                                                            ? false
                                                            : true
                                                    }
                                                />
                                            </RadioGroup>
                                        } */}
                                        {/* <Switch
                                            // checked={
                                            // }
                                            onChange={(event) =>
                                                onSwitchToggle(event)
                                            }
                                            inputProps={{ 'aria-label': 'controlled' }}
                                            color={'success'}
                                        /> */}
                                    </Paper>
                                    {/* <Paper
                                        elevation={0}
                                        className={classes.selectionContent}>
                                        <IOSFlightRequestSwitch
                                            checked={toggle}
                                            onChange={(event) =>
                                                onSwitchToggle(event)
                                            }
                                            inputProps={{
                                                'aria-label': 'controlled',
                                            }}
                                            color={'success'}
                                        />
                                    </Paper> */}
                                </Box>
                            </Grid>
                            {/* {participantList ? ( */}
                            <Grid item lg={4} md={4} xs={12}>
                                <ParticipantAutoList
                                    disableParticipant={
                                        props.transitInfo &&
                                        props.transitInfo
                                            .draftCombineAirTransportID
                                            ? true
                                            : false
                                    }
                                    participant={participant}
                                    setParticipant={changeParticipant}
                                    participantList={props.participantList}
                                    modPermission={props.modPermission}
                                />
                                {/* <Autocomplete
                                        id="size-small-standard-multi"
                                        size="small"
                                        options={participantList}
                                        getOptionLabel={(option) => option.name}
                                        renderOption={(props, option) => (
                                            <Box component='li' {...props}>{option.name}</Box>
                                        )}
                                        value={participant}
                                        onChange={(event, newValue) => {
                                            setParticipant(newValue);
                                        }}
                                        // defaultValue={[top100Films[1]]}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                placeholder="Participant"
                                            />
                                        )}
                                    /> */}
                            </Grid>
                            {/* ) : null} */}
                        </Grid>
                    </CardContent>
                </Card>

                <Grid
                    container
                    spacing={2}
                    justifyContent="center"
                    style={{ marginLeft: 0, marginTop: 0, width: '100%' 
                    }}>
                    {(tripType.get() === 'oneway' &&
                        infoType.get() == 'arrival') ||
                    tripType.get() === 'round' ? (
                        <Grid item lg={6} md={12} xs={12} 
                        sx={{
                            minWidth: tripType.get() === 'oneway' ? '80%':'50%' 
                        }} >
                            <AppBarHeader
                                title="Event Arrival Information"
                                icon="land"
                            />

                            <Grid
                                item
                                container
                                direction={{
                                    xs: 'column',
                                    sm: 'row',
                                    md: 'row',
                                    lg: 'row',
                                }}>
                                <Grid item xs>
                                    <FieldContainer
                                        {...props}
                                        justifyContent="space-around"
                                        type1="title"
                                        label1="Number of people travelling"
                                        value1=""
                                        required1={false}
                                        type2="select"
                                        // disabled2={true}
                                        label2="Number of people travelling"
                                        required2={true}
                                        value2={arrivalState.totalPassengers.get()}
                                        stateobj={arrivalState}
                                        field2="totalPassengers"
                                        onChange2={handleOnChange2}
                                        passengerCount={passengerCount}
                                    />
                                </Grid>
                                {/* <Grid item xs>
                                    <FieldContainer
                                        {...props}
                                        justifyContent="space-around"
                                        //type1="title"
                                        index={0}
                                        //label1="Ticket Type"
                                        //value1=""
                                        //required1={true}
                                        type2="ticketSelect"
                                        disabled2={
                                            props.transitID > 0
                                                ? !Helper.isAdminUser(
                                                    userInfo.get()
                                                ) &&
                                                    !(
                                                        userInfo.get().roles &&
                                                        Helper.isEventAdmin(
                                                            userInfo.get()
                                                        )
                                                    )
                                                    ? true
                                                    : false
                                                : false
                                        }
                                        label2="Ticket Type"
                                        required2={true}
                                        value2={arrivalState.ticketType.get()}
                                        stateobj={arrivalState}
                                        field2="ticketType"
                                        onChange2={handleOnChange2}
                                    />
                                </Grid> */}
                            </Grid>
                            <Typography
                                variant="caption"
                                sx={{
                                    fontSize: '.7rem',
                                    color: 'red',
                                    pl: 2.5,
                                }}
                                h5>
                                {' '}
                                Legal Name as it appears on your ID
                                {/* (for the purposes of booking your flight) */}
                            </Typography>
                            {arrivalState.peopleInfo.get() &&
                                arrivalState.peopleInfo.get().length > 0 &&
                                arrivalState.peopleInfo
                                    .get()
                                    .map((item, index) =>
                                       index < arrivalState.totalPassengers.get() ? (
                                            <Grid
                                                key={`arrive_person_${index}`}
                                                item
                                                container
                                                direction={{
                                                    xs: 'column',
                                                    sm: 'row',
                                                    md: 'row',
                                                    lg: 'row',
                                                }}>
                                                <Grid item xs>
                                                    <FieldContainer
                                                        {...props}
                                                        item={item}
                                                        index={index}
                                                        key={`arrival_people_${index}`}
                                                        justifyContent="center"
                                                        type1="title"
                                                        label1={index === 0 ? "Person Name" : `Second Person Name`}
                                                        value1=""
                                                        required1={false}
                                                        type2="text"
                                                        label2={index === 0 ? "Person Name" : `Second Person Name`}
                                                        required2={true}
                                                        value2={arrivalState.peopleInfo[
                                                            index
                                                        ]['name'].get()}
                                                        field2="name"
                                                        stateobj={arrivalState}
                                                        onChange2={
                                                            handleOnChange2
                                                        }
                                                        personErr={arrivalState.peopleInfo[0][
                                                            'err'
                                                        ].get()}
                                                    />
                                                </Grid>
                                                <Grid item xs>
                                                    <FieldContainer
                                                        {...props}
                                                        item={item}
                                                        index={index}
                                                        key={`arrival_people_${index}`}
                                                        justifyContent="center"
                                                        type1="title"
                                                        label1="DOB"
                                                        required1={false}
                                                        label2="DOB"
                                                        type2="date"
                                                        required2={false}
                                                        value2={
                                                            arrivalState
                                                                .attach(
                                                                    Downgraded
                                                                )
                                                                .get()
                                                                .peopleInfo[
                                                                index
                                                            ]['dob']
                                                        }
                                                        stateobj={arrivalState}
                                                        field2="dob"
                                                        onChange2={
                                                            handleOnChange2
                                                        }
                                                    />
                                                </Grid>
                                            </Grid>
                                        ) : null
                                    )}

                            <Grid
                                item
                                container
                                direction={{
                                    xs: 'column',
                                    sm: 'row',
                                    md: 'row',
                                    lg: 'row',
                                }}>
                                <Grid item xs>
                                    <FieldContainer
                                        {...props}
                                        justifyContent="center"
                                        type1="title"
                                        label1="Departure Airport"
                                        required1={false}
                                        type2="text"
                                        label2="Departure Airport"
                                        required2={true}
                                        value2={arrivalState.departureAirport.get()}
                                        stateobj={arrivalState}
                                        field2="departureAirport"
                                        onChange2={handleOnChange2}
                                    />
                                </Grid>
                                <Grid item xs>
                                    <FieldContainer
                                        {...props}
                                        justifyContent="center"
                                        type1="title"
                                        label1="Arrival Airport"
                                        required1={false}
                                        type2="text"
                                        label2="Arrival Airport"
                                        required2={true}
                                        value2={arrivalState.arrivalAirport.get()}
                                        stateobj={arrivalState}
                                        field2="arrivalAirport"
                                        onChange2={handleOnChange2}
                                    />
                                </Grid>
                                <Grid item xs>
                                    <FieldContainer
                                        {...props}
                                        justifyContent="center"
                                        type1="title"
                                        label1="Phone Cell No"
                                        required1={false}
                                        type2="Phonecell"
                                        label2="Phone Cell No"
                                        required2={true}
                                        value2={arrivalState.attach(Downgraded).get().contactNo}
                                        stateobj={arrivalState}
                                        field2="contactNo"
                                        onChange2={handleOnChange2}
                                        error={false}
                                    />
                                </Grid>
                            </Grid>
                            <Grid
                                item
                                container
                                direction={{
                                    xs: 'column',
                                    sm: 'row',
                                    md: 'row',
                                    lg: 'row',
                                }}>
                                <Grid item xs>
                                    <FieldContainer
                                        {...props}
                                        justifyContent="center"
                                        type1="title"
                                        label1="Departure Date"
                                        required1={false}
                                        type2="date"
                                        label2="Departure Date"
                                        required2={false}
                                        value2={
                                            arrivalState
                                                .attach(Downgraded)
                                                .get().departureDate
                                        }
                                        // disableDate={isDateDisable}
                                        stateobj={arrivalState}
                                        field2="departureDate"
                                        tripInfoType="arrival"
                                        onChange2={handleOnChange2}
                                    />
                                </Grid>
                                <Grid item xs>
                                    <FieldContainer
                                        {...props}
                                        justifyContent="center"
                                        type1="title"
                                        label1="Departure Time"
                                        required1={false}
                                        type2="time"
                                        label2="Departure Time"
                                        required2={false}
                                        value2={
                                            arrivalState
                                                .attach(Downgraded)
                                                .get().departureTime
                                        }
                                        stateobj={arrivalState}
                                        field2="departureTime"
                                        onChange2={handleOnChange2}
                                    />
                                </Grid>
                            </Grid>
                              
                            <Grid
                                item
                                container
                                direction={{
                                    xs: 'column',
                                    sm: 'row',
                                    md: 'row',
                                    lg: 'row',
                                }}>
                                <Grid item xs>
                                    <FieldContainer
                                        {...props}
                                        justifyContent="center"
                                        type1="title"
                                        label1="Arrival Date*"
                                        required1={false}
                                        type2="date"
                                        label2="Arrival Date*"
                                        minDate={minDate}
                                        maxDate={maxDate}
                                        fromDates={fromDates}
                                        required2={false}
                                        value2={
                                            arrivalState
                                                .attach(Downgraded)
                                                .get().arrivalDate
                                        }
                                        // disableDate={isDateDisable}
                                        stateobj={arrivalState}
                                        field2="arrivalDate"
                                        tripInfoType="arrival"
                                        onChange2={handleOnChange2}
                                        dateDisabled={dateDisabled}
                                        disableallDates={disableallDates}
                                    />
                                </Grid>
                                <Grid item xs>
                                    <FieldContainer
                                        {...props}
                                        justifyContent="center"
                                        type1="title"
                                        label1="Arrival Time *"
                                        required1={false}
                                        type2="time"
                                        label2="Arrival Time *"
                                        required2={false}
                                        value2={
                                            arrivalState
                                                .attach(Downgraded)
                                                .get().arrivalTime
                                        }
                                        stateobj={arrivalState}
                                        field2="arrivalTime"
                                        onChange2={handleOnChange2}
                                    />
                                </Grid>
                            </Grid>
                            <Grid
                                item
                                container
                                direction={{
                                    xs: 'column',
                                    sm: 'row',
                                    md: 'row',
                                    lg: 'row',
                                }}>
                                <Grid item xs>
                                    <FieldContainer
                                        {...props}
                                        justifyContent="center"
                                        type1="title"
                                        label1="Airline"
                                        required1={false}
                                        type2="text"
                                        label2="Airline"
                                        required2={true}
                                        value2={arrivalState.arrivalAirline.get()}
                                        stateobj={arrivalState}
                                        field2="arrivalAirline"
                                        onChange2={handleOnChange2}
                                    />
                                </Grid>
                                <Grid item xs>
                                    <FieldContainer
                                        {...props}
                                        justifyContent="center"
                                        type1="title"
                                        label1={
                                            arrivalState.isPrivate.get() ===
                                                true ||
                                            departureState.isPrivate.get() ===
                                                true
                                                ? 'Tail No.'
                                                : 'Flight No.'
                                        }
                                        required1={true}
                                        type2="text"
                                        label2={
                                            arrivalState.isPrivate.get() ===
                                                true ||
                                            departureState.isPrivate.get() ===
                                                true
                                                ? 'Tail No.'
                                                : 'Flight No.'
                                        }
                                        required2={true}
                                        value2={arrivalState.arrivalFlightNo.get()}
                                        stateobj={arrivalState}
                                        field2="arrivalFlightNo"
                                        onChange2={handleOnChange2}
                                    />
                                </Grid>
                            </Grid>
                            <Grid
                                item
                                container
                                direction={{
                                    xs: 'column',
                                    sm: 'row',
                                    md: 'row',
                                    lg: 'row',
                                }}>
                                <Grid item xs>
                                    <FieldContainer
                                        {...props}
                                        justifyContent="center"
                                        type1="arrivaltext"
                                        label1="Comments"
                                        required1={false}
                                        type2="arrivaltext"
                                        label2="Comments"
                                        required2={false}
                                        value2={arrivalState.arrivalComments.get()}
                                        stateobj={arrivalState}
                                        field2="arrivalComments"
                                        onChange2={handleOnChange2}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    ) : null}
                    {(tripType.get() === 'oneway' &&
                        infoType.get() == 'departure') ||
                    tripType.get() === 'round' ? (
                        <Grid item lg={6} md={12} xs={12}
                        sx={{
                            minWidth: tripType.get() === 'oneway' ? '80%':'50%' 
                        }}
                        >
                            <AppBarHeader
                                title="Event Departure Information"
                                icon="takeoff"
                            />

                            <Grid
                                item
                                container
                                direction={{
                                    xs: 'column',
                                    sm: 'row',
                                    md: 'row',
                                    lg: 'row',
                                }}>
                                <Grid item xs>
                                    <FieldContainer
                                        {...props}
                                        justifyContent="space-around"
                                        type1="title"
                                        label1="Number of people travelling"
                                        required1={false}
                                        type2="select"
                                        // disabled2={true}
                                        label2="Number of people travelling"
                                        required2={true}
                                        value2={departureState.totalPassengers.get()}
                                        stateobj={departureState}
                                        field2="totalPassengers"
                                        onChange2={handleOnChange2}
                                        inputProps={{
                                            inputProps: {
                                                max: 3,
                                                min: 1,
                                            },
                                        }}
                                        passengerCount={passengerCount}
                                    />
                                </Grid>
                                {/* <Grid item xs>
                                    <FieldContainer
                                        {...props}
                                        justifyContent="space-around"
                                        //type1="title"
                                        //label1="Ticket Type"
                                        // value1=""
                                        index={0}
                                        //required1={true}
                                        type2="ticketSelect"
                                        disabled2={
                                            props.transitID > 0
                                                ? !Helper.isAdminUser(
                                                    userInfo.get()
                                                ) &&
                                                    !(
                                                        userInfo.get().roles &&
                                                        Helper.isEventAdmin(
                                                            userInfo.get()
                                                        )
                                                    )
                                                    ? true
                                                    : false
                                                : false
                                        }
                                        label2="Ticket Type"
                                        required2={true}
                                        value2={departureState.ticketType.get()}
                                        stateobj={departureState}
                                        field2="ticketType"
                                        onChange2={handleOnChange2}
                                    />
                                </Grid> */}
                            </Grid>
                            <Typography
                                variant="caption"
                                sx={{
                                    fontSize: '.7rem',
                                    color: 'red',
                                    pl: 2.5,
                                }}
                                h5>
                                {' '}
                                Legal Name as it appears on your ID
                                {/* (for the purposes of booking your flight) */}
                            </Typography>
                            {departureState.peopleInfo.get() &&
                            departureState.peopleInfo.get().length > 0
                                ? departureState.peopleInfo
                                      .get()
                                      .map((item, index) => (
                                         index < departureState.totalPassengers.get() ?  (
                                          <Grid
                                              key={`depart_person_${index}`}
                                              item
                                              container
                                              direction={{
                                                  xs: 'column',
                                                  sm: 'row',
                                                  md: 'row',
                                                  lg: 'row',
                                              }}>
                                              <Grid item xs>
                                                  <FieldContainer
                                                      {...props}
                                                      item={item}
                                                      index={index}
                                                      key={`depart_people_${index}`}
                                                      justifyContent="center"
                                                      type1="title"
                                                      label1={index === 0 ? "Person Name" : `Second Person Name`}
                                                      required1={false}
                                                      type2="text"
                                                      label2={index === 0 ? "Person Name" : `Second Person Name`}
                                                      required2={true}
                                                      value2={departureState.peopleInfo[
                                                          index
                                                      ]['name'].get()}
                                                      field2="name"
                                                      stateobj={departureState}
                                                      onChange2={
                                                          handleOnChange2
                                                      }
                                                      personErr={departureState.peopleInfo[0][
                                                          'err'
                                                      ].get()}
                                                  />
                                              </Grid>

                                              <Grid item xs>
                                                  <FieldContainer
                                                      {...props}
                                                      item={item}
                                                      index={index}
                                                      key={`depart_people_${index}`}
                                                      justifyContent="center"
                                                      type1="title"
                                                      label1="DOB"
                                                      required1={false}
                                                      label2="DOB"
                                                      type2="date"
                                                      required2={false}
                                                      value2={
                                                          departureState
                                                              .attach(
                                                                  Downgraded
                                                              )
                                                              .get().peopleInfo[
                                                              index
                                                          ]['dob']
                                                      }
                                                      stateobj={departureState}
                                                      dateDisabled={
                                                          dateDOBDisabled
                                                      }
                                                      field2="dob"
                                                      onChange2={
                                                          handleOnChange2
                                                      }
                                                  />
                                              </Grid>
                                          </Grid>
                                      ): null)) 
                                : null}

                            <Grid
                                item
                                container
                                direction={{
                                    xs: 'column',
                                    sm: 'row',
                                    md: 'row',
                                    lg: 'row',
                                }}>
                                <Grid item xs>
                                    <FieldContainer
                                        {...props}
                                        justifyContent="center"
                                        type1="title"
                                        label1="Departure Airport"
                                        required1={false}
                                        type2="text"
                                        label2="Departure Airport"
                                        required2={true}
                                        value2={departureState.departureAirport.get()}
                                        stateobj={departureState}
                                        field2="departureAirport"
                                        onChange2={handleOnChange2}
                                    />
                                </Grid>
                                <Grid item xs>
                                    <FieldContainer
                                        {...props}
                                        {...props}
                                        justifyContent="center"
                                        type1="title"
                                        label1="Arrival Airport"
                                        required1={false}
                                        type2="text"
                                        label2="Arrival Airport"
                                        required2={true}
                                        value2={departureState.arrivalAirport.get()}
                                        stateobj={departureState}
                                        field2="arrivalAirport"
                                        onChange2={handleOnChange2}
                                    />
                                </Grid>
                                <Grid item xs>
                                    <FieldContainer
                                        {...props}
                                        justifyContent="center"
                                        type1="title"
                                        label1="Phone Cell No"
                                        required1={false}
                                        type2="Phonecell"
                                        label2="Phone Cell No"
                                        required2={true}
                                        value2={arrivalState.attach(Downgraded).get().contactNo}
                                        stateobj={arrivalState}
                                        field2="contactNo"
                                        onChange2={handleOnChange2}
                                        error={false}
                                    />
                                </Grid>
                            </Grid>
                            <Grid
                                item
                                container
                                direction={{
                                    xs: 'column',
                                    sm: 'row',
                                    md: 'row',
                                    lg: 'row',
                                }}>
                                <Grid item xs>
                                    <FieldContainer
                                        {...props}
                                        justifyContent="center"
                                        type1="title"
                                        label1="Departure Date*"
                                        required1={false}
                                        type2="date"
                                        label2="Departure Date*"
                                        minDate={minDate}
                                        maxDate={maxDate}
                                        toDates={toDates}
                                        required2={true}
                                        value2={
                                            departureState
                                                .attach(Downgraded)
                                                .get().departureDate
                                        }
                                        // disableDate={isDateDisable}
                                        stateobj={departureState}
                                        field2="departureDate"
                                        tripInfoType="departure"
                                        onChange2={handleOnChange2}
                                        disableallDates={disableallDates}
                                    />
                                </Grid>
                                <Grid item xs>
                                    <FieldContainer
                                        {...props}
                                        justifyContent="center"
                                        type1="title"
                                        label1="Departure Time*"
                                        required1={false}
                                        type2="time"
                                        label2="Departure Time*"
                                        required2={false}
                                        value2={
                                            departureState
                                                .attach(Downgraded)
                                                .get().departureTime
                                        }
                                        stateobj={departureState}
                                        field2="departureTime"
                                        onChange2={handleOnChange2}
                                    />
                                </Grid>
                            </Grid>
                            <Grid
                                item
                                container
                                direction={{
                                    xs: 'column',
                                    sm: 'row',
                                    md: 'row',
                                    lg: 'row',
                                }}>
                                <Grid item xs>
                                    <FieldContainer
                                        {...props}
                                        justifyContent="center"
                                        type1="title"
                                        label1="Arrival Date"
                                        required1={false}
                                        type2="date"
                                        label2="Arrival Date"
                                        required2={false}
                                        value2={
                                            departureState
                                                .attach(Downgraded)
                                                .get().arrivalDate
                                        }
                                        // disableDate={isDateDisable}
                                        stateobj={departureState}
                                        field2="arrivalDate"
                                        tripInfoType="departure"
                                        onChange2={handleOnChange2}
                                    />
                                </Grid>
                                <Grid item xs>
                                    <FieldContainer
                                        {...props}
                                        justifyContent="center"
                                        type1="title"
                                        label1="Arrival Time"
                                        required1={false}
                                        type2="time"
                                        label2="Arrival Time"
                                        required2={false}
                                        value2={
                                            departureState
                                                .attach(Downgraded)
                                                .get().arrivalTime
                                        }
                                        stateobj={departureState}
                                        field2="arrivalTime"
                                        onChange2={handleOnChange2}
                                    />
                                </Grid>
                            </Grid>
                            <Grid
                                item
                                container
                                direction={{
                                    xs: 'column',
                                    sm: 'row',
                                    md: 'row',
                                    lg: 'row',
                                }}>
                                <Grid item xs>
                                    <FieldContainer
                                        {...props}
                                        justifyContent="center"
                                        type1="title"
                                        label1="Airline"
                                        required1={false}
                                        type2="text"
                                        label2="Airline"
                                        required2={true}
                                        value2={departureState.departureAirline.get()}
                                        stateobj={departureState}
                                        field2="departureAirline"
                                        onChange2={handleOnChange2}
                                    />
                                </Grid>
                                <Grid item xs>
                                    <FieldContainer
                                        {...props}
                                        justifyContent="center"
                                        type1="title"
                                        label1={
                                            arrivalState.isPrivate.get() ===
                                                true ||
                                            departureState.isPrivate.get() ===
                                                true
                                                ? 'Tail No.'
                                                : 'Flight No.'
                                        }
                                        required1={false}
                                        type2="text"
                                        label2={
                                            arrivalState.isPrivate.get() ===
                                                true ||
                                            departureState.isPrivate.get() ===
                                                true
                                                ? 'Tail No.'
                                                : 'Flight No.'
                                        }
                                        required2={true}
                                        value2={departureState.departureFlightNo.get()}
                                        stateobj={departureState}
                                        field2="departureFlightNo"
                                        onChange2={handleOnChange2}
                                    />
                                </Grid>
                            </Grid>

                            <Grid
                                item
                                container
                                direction={{
                                    xs: 'column',
                                    sm: 'row',
                                    md: 'row',
                                    lg: 'row',
                                }}>
                                <Grid item xs>
                                    <FieldContainer
                                        {...props}
                                        justifyContent="center"
                                        type1="departuretext"
                                        label1="Comments"
                                        required1={false}
                                        type2="departuretext"
                                        label2="Comments"
                                        required2={false}
                                        value2={departureState.departureComments.get()}
                                        stateobj={departureState}
                                        field2="departureComments"
                                        onChange2={handleOnChange2}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    ) : null}
                    <Divider component="div" />
                    {(tripType.get() === 'oneway' &&
                        (infoType.get() == 'departure' ||
                            infoType.get() == 'arrival')) ||
                    tripType.get() === 'round' ? (
                        <Grid
                            item
                            xs={12}
                            sx={{
                                display: 'flex',
                                justifyContent: 'flex-end',
                            }}>
                            <Button
                                variant="contained"
                                size="small"
                                sx={{ marginTop: '16px' }}
                                onClick={backToListing}>
                                Back
                            </Button>
                            <ButtonContainer
                                // handleClick={handleBtnClick}
                                handleCancel={handleBtnCancel}
                                buttonText={
                                    props.transitID > 0 ? 'Update' : 'Create'
                                }
                                disableButton={disableButton.get()}
                                disableUpdateButton={
                                    props.transitID > 0 ? disableBtn : false
                                }
                            />
                        </Grid>
                    ) : null}
                </Grid>
            </Box>
        </>
    );
};
export default AirTransport;
